import React from "react"
import cn from "classnames"

import pushToDataLayer from "@ecom/ui/utils/pushToDataLayer"

import clsx from "clsx"
import { AppLink } from "@ecom/ui/components/AppLink"
import Content from "../Content"
import { Requirements } from "../Requirements"
import { RequirementsRefin } from "../RequirementsRefin"
import { FAQBlock, FAQQuestion, FAQAnswer } from "../FAQ"

import pdf3NDFL from "../../../static/documentPdf/Схема_заполнения декларации в ЛК.pdf"
import pdfPlanetaCard from "../../../static/documentPdf/ПП КХ PLANRETACARD-AURACARD для ТРК Пр1 к Пр2109.pdf"
import { SvgPDF } from "../img/SvgPDF"

import * as styles from "../switcherTextBlock.module.scss"
import { MoreFiles } from "../FAQ/MoreFiles/MoreFiles"
import { QueryTypePsk } from "../../../helpers/getVariableFromQuery"
import { DLClickEventExtended } from "../../../helpers/WatcherDL/DLEvents"
import { ExpertOpinion } from "../../ExpertOpinion/ExpertOpinion"
import {
  EXPERT_ALEXANDRA_MELNIK,
  EXPERT_ARTUR_SAFIN,
  EXPERT_ILVINA_HAZIEVA,
} from "../../ExpertOpinion/helpers"
import { RequirementsSticker } from "../RequirementsSticker"

const handleClick = (e: React.MouseEvent<HTMLButtonElement>, expanded: boolean) => {
  const dataLayerData = {
    name: e.currentTarget.textContent!,
    actionType: expanded ? "open_question" : "close_question",
  }
  pushToDataLayer(dataLayerData)
}

const handleClickRefin = (e: React.MouseEvent<HTMLButtonElement>, expanded: boolean) => {
  const dataLayerData = {
    name: e.currentTarget.textContent!,
    actionType: expanded ? "open_question" : "close_question",
  }
  pushToDataLayer(dataLayerData)
  if (expanded) {
    pushToDataLayer({
      event: "buttonClick",
      name: "dropdown_useful_information",
      placement: "useful_information",
    })
  }
}

const BENEFITS_LIST_PKW_CREDIT_CARDS = [
  {
    title: <>До 300 дней без процентов за покупки</>,
    descr: (
      <>Делайте покупки сейчас, а погашайте задолженность позже и&nbsp;не&nbsp;платите проценты.</>
    ),
  },
  {
    title: <>Бесплатное снятие наличных</>,
    descr: <>Снимайте деньги без комиссии в&nbsp;любых банкоматах.</>,
  },
  {
    title: <>Удобное пополнение карты</>,
    descr: (
      <>
        В мобильном приложении{" "}
        <AppLink rel="nofollow noopener noreferrer" target="_blank" href="https://pwa.scb.ru/">
          «Халва – Совкомбанк»
        </AppLink>
        , в&nbsp;личном кабинете или&nbsp;в&nbsp;любом отделении банка.
      </>
    ),
  },
  { title: <>Выпуск и обслуживание — 0 ₽</>, descr: <>Всегда бесплатное обслуживание.</> },
]

const DESCRIPRION_PKW_CREDIT_CARDS = [
  {
    title: <>Преимущества кредитной карты без % от Совкомбанка</>,
    descr: (
      <>
        Комфортная карта на каждый день: до&nbsp;300 дней льготного периода и&nbsp;снятие наличных
        без&nbsp;комиссии.
        <br />
        Не платите за оформление кредитки: выпуск и&nbsp;обслуживание бесплатные.
      </>
    ),
  },
  {
    title: <>Как пользоваться картой</>,
    descr: (
      <>
        Так же, как и любой другой картой. В&nbsp;течение льготного периода вы можете делать
        покупки, а&nbsp;в&nbsp;нужный момент просто пополните карту одним из&nbsp;способов:
        <br />
        - через банкоматы и устройства самообслуживания в&nbsp;отделении Совкомбанка;
        <br />- в мобильном приложении{" "}
        <AppLink rel="nofollow noopener noreferrer" target="_blank" href="https://pwa.scb.ru/">
          «Халва — Совкомбанк»
        </AppLink>
        .
      </>
    ),
  },
  {
    title: <>Как оформить кредитную карту без %</>,
    descr: (
      <>
        Вы можете заполнить заявку онлайн на&nbsp;сайте прямо сейчас.
        <br />
        Также заявку можно оставить по&nbsp;телефону и&nbsp;забрать карту в&nbsp;ближайшем
        для&nbsp;вас офисе.
        <br />
        Для оформления нужен только паспорт. Могут потребоваться дополнительные документы
        в&nbsp;зависимости от&nbsp;вашей ситуации.
      </>
    ),
  },
]

const DOCUMENTS_PKW_CREDIT_CARDS = [
  {
    text: <>Акция 300 дней без процентов (действует с&nbsp;01.06.2026)</>,
    href: "https://scb.ru/document/18431",
    size: "643 Кб",
  },
  {
    text: (
      <>
        Тарифы по продукту Кредитная карта 180 дней без&nbsp;процентов{" "}
        <br className="d-none d-md-block" />
        (действует с&nbsp;01.06.2026)
      </>
    ),
    href: "https://scb.ru/document/18827",
    size: "284 Кб",
  },
  {
    text: (
      <>
        Общие условия по продукту Кредитная карта 180 дней без&nbsp;процентов{" "}
        <br className="d-none d-md-block" />
        (действуют с&nbsp;28.06.2026г.)
      </>
    ),
    href: "https://scb.ru/document/18699",
    size: "575 Кб",
  },
  {
    text: <>Тарифы продукта Подписка Оптима (действуют с&nbsp;25.06.2026) </>,
    href: "https://scb.ru/document/18256",
    size: "225 КБ",
  },
  {
    text: <>Акции по Халве | Зелёная цена на покупки в OZON по картам Банка (с 04.05.2026)</>,
    href: "https://scb.ru/document/18990",
    size: "891 КБ",
  },
]

const QUESTIONS_LIST = {
  pravdacoffee: [
    [
      <p className={styles.listQuestion}>Более 260 000 магазинов для выгодных покупок</p>,
      <div className={styles.listAnswer}>
        С картой «Халва» сотрудничают{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://halvacard.ru/partners"
        >
          более 260&nbsp;000 партнёров
        </AppLink>
        , у которых покупки можно делать с&nbsp;рассрочкой. Сумма каждой такой покупки делится
        на&nbsp;равные части (по&nbsp;количеству месяцев рассрочки у партнёра). Раз в&nbsp;месяц
        «части» по&nbsp;всем покупкам суммируются и&nbsp;выставляются единым Платежом
        по&nbsp;рассрочке (дата выставления платежа равна дате оформления Халвы).
        <br />
        Подключите{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://halvacard.ru/halvadesyatka"
        >
          подписку «Халва.Десятка»
        </AppLink>{" "}
        и&nbsp;делайте любые покупки у&nbsp;партнёров с&nbsp;единым увеличенным сроком рассрочки
        10&nbsp;месяцев.
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Преимущества подписки «Халва.Десятка»</p>,
      <div className={styles.listAnswer}>
        Подключите подписку «Халва.Десятка» и за 0 рублей<sup className={styles.supIndex}>4</sup>{" "}
        попробуйте все её преимущества:
        <ul className={styles.listStyleDisc}>
          <li>
            <b>10 месяцев рассрочки* на&nbsp;покупки.</b> Единый увеличенный срок рассрочки*
            в&nbsp;260&nbsp;000{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/shops/special"
            >
              магазинах-партнёрах
            </AppLink>{" "}
            Халвы<sup className={styles.supIndex}>6</sup>
          </li>
          <li>
            <b>
              Удвоение{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/document?id=2777"
              >
                кешбэка
              </AppLink>
              .
            </b>{" "}
            В 2 раза больше кешбэка за&nbsp;каждую покупку или поездку на Яндекс GO – возвращайте
            до&nbsp;10% от&nbsp;стоимости.
          </li>
          <li>
            <b>Увеличенный лимит кешбэка в месяц 5 000.</b> Получайте больше кешбэка по карте.
          </li>
          <li>
            <b>+5% к&nbsp;ставке вкладов.</b> Увеличение<sup className={styles.supIndex}>2</sup>{" "}
            на&nbsp;+5% по&nbsp;вкладам на&nbsp;сроке 36&nbsp;мес., +2% на&nbsp;сроке 24&nbsp;мес.
            (+1% на&nbsp;других сроках) при ежемесячном выполнении условия: от&nbsp;10 покупок
            по&nbsp;Халве на&nbsp;общую сумму от&nbsp;20&nbsp;000&nbsp;₽
            <sup className={styles.supIndex}>1</sup>
          </li>
          <li>
            <b>+1% к ставке Онлайн-копилки.</b> Увеличение базовой ставки
            <sup className={styles.supIndex}>7</sup>
          </li>
          <li>
            <b>3 месяца рассрочки.</b> На снятия, переводы и&nbsp;покупки заёмными средствами
            не&nbsp;у&nbsp;партнеров;
          </li>
          <li>
            <b>Бесплатный стикер Рау.</b> Для удобной оплаты телефоном и&nbsp;повышенного кешбэка
          </li>
          <li>
            <b>Комплексная IT-защита.</b> Онлайн-консультация эксперта при неисправностях и сбоях в
            работе компьютера или смартфона
          </li>
          <li>
            <b>Помощник по покупкам.</b> Личный консультант подберет для вас нужный товар с лучшей
            ценой и сроком рассрочки
          </li>
          <li>
            <b>Страхование жизни и&nbsp;здоровья.</b> Выплаты при болезнях или несчастных случаях (в
            т.ч. от БПЛА)
          </li>
          <li>
            <b>Страхование покупок.</b> Возмещение при&nbsp;повреждении или&nbsp;поломке важных
            покупок, а&nbsp;также юридическая помощь по&nbsp;правам покупателей;
          </li>
        </ul>
        <p>
          И это ещё не всё! Вместе с Подпиской вы можете подключить опцию «Всё и везде» и за 0
          рублей5 попробовать бесплатную рассрочку на 3 месяца без комиссии:
          <br />
          <ul className={styles.listStyleDisc}>
            <li>на любые покупки вне партнёрской сети.</li>
          </ul>
        </p>
        <p>
          Подписку и суперопцию «Всё и везде» выгодно подключать вместе. Все подробности{" "}
          <AppLink
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://halvacard.ru/halvadesyatka"
          >
            здесь
          </AppLink>
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Акция «24 месяца рассрочки» на рефинансирование кредитных карт
      </p>,
      <div className={styles.listAnswer}>
        В течение 1-го месяца после оформления карты<sup className={styles.supIndex}>8</sup> вы
        можете получить 24 месяца рассрочки на рефинансирование задолженности по кредитным картам
        любых банков.
        <br />
        Чтобы увеличенный<sup className={styles.supIndex}>9</sup> срок рассрочки сохранялся, нужно:
        <br />
        <ul className={styles.listStyleDisc}>
          <li>
            делать ежемесячно от&nbsp;10 покупок на&nbsp;сумму от&nbsp;20&nbsp;000 рублей
            <sup className={styles.supIndex}>1</sup>;{" "}
          </li>
          <li>своевременно вросить стандартные платежи по рассрочке; </li>
          <li>закрыть кредитные карты. </li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Снятие наличных в рассрочку</p>,
      <div className={styles.listAnswer}>
        <p>
          Вы можете снимать заёмные средства с Халвы в рассрочку на 3 месяца с подпиской{" "}
          <AppLink
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://halvacard.ru/halvadesyatka"
          >
            «Халва.Десятка»
          </AppLink>{" "}
          (без подписки на 2 мес.). За одну операцию можно получить до 30 000 рублей, количество
          операций не ограничено. Стоимость услуги — 499 ₽ за каждую операцию.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Бесплатный выпуск и обслуживание</p>,
      <div className={styles.listAnswer}>
        <p>
          Бесплатный выпуск карты:{" "}
          <AppLink
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://halvacard.ru/order/"
          >
            онлайн
          </AppLink>{" "}
          24/7 с доставкой курьером или в любом офисе Банка.
        </p>
        <br />
        <p>Бесплатное обслуживание: вы не платите за годовое обслуживание и перевыпуск.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Принимается везде</p>,
      <div className={styles.listAnswer}>
        <p>Оплачивайте любые покупки вашей картой в любых магазинах.</p>
        <br />
        <p>Вы можете использовать её и как карту рассрочки, и как доходную карту.</p>
        <br />
        <p>
          Настройте удобный режим карты «Халва» под себя, прежде чем ею пользоваться. В мобильном
          приложении или{" "}
          <AppLink rel="nofollow noopener noreferrer" target="_blank" href="https://pwa.scb.ru/">
            личном кабинете
          </AppLink>{" "}
          выберите:
        </p>
        <br />
        <p>
          <span style={{ fontWeight: "bold" }}>
            Какие средства использовать в 1-ю очередь (заёмные или собственные)?
          </span>
        </p>
        <ul className={styles.listStyleDisc}>
          <li>Сначала заёмные, потом свои;</li>
          <li>Сначала свои, потом заёмные;</li>
          <li>Только свои (все операции только своими деньгами).</li>
        </ul>
        <br />
        <p>
          <span style={{ fontWeight: "bold" }}>Где доступна рассрочка?</span>
        </p>
        <br />
        <p>
          <span style={{ fontStyle: "italic" }}>Только у партнёров</span>
        </p>
        <br />
        <ul className={styles.listStyleDisc}>
          <li>у партнёров до 24 месяцев;</li>
          <li>не у партнёров покупки только своими деньгами.</li>
        </ul>
        <br />
        <p>
          <span style={{ fontStyle: "italic" }}>В любых магазинах</span>
        </p>
        <ul className={styles.listStyleDisc}>
          <li>не у партнёров покупки с комиссией:</li>
          <ul>
            <li>- 9 руб. за покупки до 99,99 руб.</li>
            <li>- 99 руб. за покупки от 100 руб.</li>
          </ul>
        </ul>
        в рассрочку 3 мес. с подпиской{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://halvacard.ru/halvadesyatka/"
        >
          «Халва.Десятка»
        </AppLink>{" "}
        (без подписки на 2 мес.). Без комиссии с{" "}
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://halvacard.ru/halvadesyatka/"
        >
          суперопцией «Всё и везде»
        </AppLink>
        .
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Уменьшайте платежи по рассрочке с опцией «Минимальный платёж»
      </p>,
      <div className={styles.listAnswer}>
        <p>
          Это ваша «финансовая подушка безопасности». Если по каким-то причинам у вас не получается
          внести Платёж по рассрочке целиком, то вы сможете заплатить Минимальный платёж. Он равен
          всего 1/20 от задолженности.
        </p>
        <br />
        <p>
          За пользование опцией начисляется комиссия – 3,9% от задолженности, которая удерживается
          только в случае невнесения полного Платежа по рассрочке.
        </p>
        <br />
        <p>
          Разница между Минимальным платежом и обычным Платежом по рассрочке перенесется на
          следующий месяц и добавится к будущему Платежу по рассрочке.
        </p>
        <br />
        <p>
          Как работает данная опция – разберём на примере:
          <ul>
            <li>- Вы сделали покупку на 15000 ₽ с рассрочкой на 3 месяца.</li>
            <li>- Ваш Платеж без процентов = 15000 / 3 = 5000 ₽</li>
            <li>- Ваш Минимальный платеж = 15000 / 20 = 750 ₽</li>
            <li>- Комиссия за Минимальный платеж = 15000 * 3,9% = 585 ₽</li>
            <li>
              - Если вы внесёте Минимальный платеж, то следующий Платеж по задолженности составит =
              9 835 ₽:
            </li>
          </ul>
          <ul className={styles.listStyleDisc}>
            <li>5000 ₽ – обычный платеж по графику рассрочки;</li>
            <li>
              4250 ₽ – долг с прошлого платежа (5000 ₽ размер обычного Платежа по рассрочке минус
              750 ₽ Минимальный платеж вы уже внесли);
            </li>
            <li>585 ₽ – комиссия за услугу Минимальный платёж.</li>
          </ul>
        </p>
        <br />
        <p>
          После погашения Платежа по рассрочке или Минимального платежа» (об этом вам поступит
          уведомление) лимитом кредитования можно сразу же пользоваться снова.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Бесплатное пополнение карты, удобное погашение платежей
      </p>,
      <div className={styles.listAnswer}>
        <p style={{ fontWeight: "bold" }}>Удобно пополнять карту и погашать платежи:</p>
        <br />
        <ul className={styles.listStyleDisc}>
          <li>
            через Систему быстрых платежей (СБП) или с других счетов Совкомбанка онлайн: через
            приложение{" "}
            <AppLink rel="nofollow noopener noreferrer" target="_blank" href="https://pwa.scb.ru/">
              «Халва – Совкомбанк»
            </AppLink>{" "}
            или{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/lk2/"
            >
              в личном кабинете
            </AppLink>
            ;
          </li>
          <li>наличными в устройствах самообслуживания Совкомбанка.</li>
        </ul>
        <br />
        <p>
          В мобильном приложении также можно{" "}
          <AppLink
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://halvacard.ru/lk2/"
          >
            настроить регулярное автопополнение карты
          </AppLink>
          !
        </p>
        <br />
        <p>
          <span style={{ fontWeight: "bold" }}>
            Дополнительно вы можете использовать следующие способы (может взиматься комиссия):
          </span>
          <ul>
            <li>
              переводы онлайн на карту — на{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://pay.cardstandard.ru/c2c/sovcombank/form/"
              >
                сайте
              </AppLink>{" "}
              Банка или через любые сторонние сервисы;
            </li>
            <li>в отделениях Почты России;</li>
            <li>банковским переводом по реквизитам.</li>
          </ul>
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Кешбэк до 10%</p>,
      <div className={styles.listAnswer}>
        <p>
          <AppLink
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://scb.ru/document/2777"
          >
            Баллы кешбэка
          </AppLink>{" "}
          начисляются за любые покупки собственными средствами. Они суммируются и становятся
          доступными для обмена после окончания текущего отчётного периода, если в нём накоплено от
          300 баллов*.
        </p>
        <br />
        <p>Обменять баллы можно:</p>
        <br />
        <ul>
          <li>
            - на промокоды для скидок в магазинах-партнёрах Халвы с двойной или даже тройной
            выгодой;{" "}
          </li>
          <li>- на рубли по курсу: 1 балл = 1 рублю.</li>
        </ul>
        <br />
        <p style={{ fontWeight: "bold" }}>
          При подключении подписки{" "}
          <AppLink
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://halvacard.ru/halvadesyatka"
          >
            «Халва.Десятка»
          </AppLink>
          <sup className={styles.supIndex}>4</sup> кешбэк УДВАИВАЕТСЯ!
        </p>
        <p style={{ fontWeight: "bold" }}>
          Размер{" "}
          <AppLink
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://scb.ru/document/2777"
          >
            кешбэка
          </AppLink>{" "}
          <sup className={styles.supIndex}>3</sup>
        </p>
        <br />
        <table className={styles.cashbackTable}>
          <thead>
            <tr>
              <th className={styles.headerCell}>Тип операции</th>
              <th className={styles.headerCell}>
                С подпиской{" "}
                <AppLink
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  href="https://halvacard.ru/halvadesyatka/"
                >
                  «Халва.Десятка»
                </AppLink>
              </th>
              <th className={styles.headerCell}>Без подписки</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Покупка в&nbsp;магазинах-партнёрах Халвы</td>
              <td>4%</td>
              <td>2%</td>
            </tr>
            <tr>
              <td>
                Покупка в&nbsp;магазинах-партнёрах от 10&nbsp;000&nbsp;₽ при оплате телефоном**,
                стикером, в&nbsp;Интернете
              </td>
              <td>10%</td>
              <td>5%</td>
            </tr>
            <tr>
              <td>Оплата поездки на&nbsp;такси «Яндекс Go»</td>
              <td>10%</td>
              <td>5%</td>
            </tr>
            <tr>
              <td>
                Покупка не&nbsp;у&nbsp;партнёра или&nbsp;оплата ЖКХ в&nbsp;приложении{" "}
                <AppLink
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  href="https://pwa.scb.ru/"
                >
                  «Халва - Совкомбанк»
                </AppLink>{" "}
                или{" "}
                <AppLink
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  href="https://halvacard.ru/lk2/"
                >
                  личном кабинете
                </AppLink>
              </td>
              <td>2%</td>
              <td>1%</td>
            </tr>
          </tbody>
        </table>
        <p>
          * Если за отчетный период накоплено менее 300 баллов, то они переносятся на&nbsp;следующий
          отчетный период и&nbsp;суммируются с&nbsp;баллами, которые будут в&nbsp;нём накоплены.
        </p>
        <br />{" "}
        <p>
          Продолжайте активно пользоваться картой, чтобы быстрее накопить необходимое для возмещения
          количество баллов.
        </p>
        <br />
        <p>
          ** При оплате с&nbsp;помощью сервиса Пэй (для Андроид) или&nbsp;оплата Айфоном (для iOS).
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Доставка карты курьером</p>,
      <div className={styles.listAnswer}>
        <p>Нет возможности приехать за&nbsp;Халвой — она приедет к&nbsp;вам сама!</p>
        <br />
        <p>
          Просто{" "}
          <AppLink
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://halvacard.ru/order/"
          >
            оставьте заявку
          </AppLink>
          , и наш курьер доставит вам карту с лимитом рассрочки в удобное время и удобное место в
          одном из{" "}
          <AppLink
            rel="nofollow noopener noreferrer"
            target="_blank"
            href="https://scb.ru/delivery-map"
          >
            74 регионов
          </AppLink>{" "}
          России (также вы можете прийти за картой с лимитом рассрочки лично в офис). Карту без
          лимита рассрочки можно забрать только в офисе.
        </p>
      </div>,
    ],
  ],
  planetacard: [
    [
      <p className={styles.listQuestion}>Халва – кредитная или&nbsp;дебетовая карта?</p>,
      <div className={styles.listAnswer}>
        Халва – универсальная карта, которую можно использовать одновременно как&nbsp;дебетовую
        и&nbsp;карту рассрочки*. Сменить режим можно легко в&nbsp;приложении «Халва – Совкомбанк».
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Какой минимальный и&nbsp;максимальный лимит рассрочки*?
      </p>,
      <div className={styles.listAnswer}>
        Минимальный лимит по&nbsp;карте «Халва» — 0,1&nbsp;руб. Максимальный лимит составляет
        500&nbsp;000&nbsp;руб. Чтобы увеличить лимит, выполняйте Правило 10×20 и&nbsp;регулярно
        совершайте покупки по&nbsp;карте. Чем&nbsp;активнее вы пользуетесь Халвой, тем&nbsp;выше
        вероятность увеличения лимита.
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Влияет ли наличие карты на&nbsp;кредитную нагрузку?</p>,
      <div className={styles.listAnswer}>
        Поскольку с помощью Халвы вы покупаете товары в&nbsp;рассрочку*, наличие задолженности
        по&nbsp;карте влияет на&nbsp;кредитную нагрузку. Банк будет относиться к&nbsp;вам более
        лояльно, если вы будете активно пользоваться картой и&nbsp;своевременно вносить платежи.
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Насколько надежен банк, который выпускает карту? Где о&nbsp;нем можно узнать информацию?
      </p>,
      <div className={styles.listAnswer}>
        Халва — это проект Совкомбанка. Вся информация о&nbsp;его надежности — лицензии, реквизиты,
        рейтинги финансовой организации — собрана на&nbsp;
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://scb.ru/about/info"
        >
          отдельной странице
        </AppLink>
        .<br />
        <br /> Совкомбанк зарекомендовал себя как&nbsp;надежная организация и&nbsp;не&nbsp;раз
        лидировал в &nbsp;народных рейтингах:{" "}
        <ul className={styles.listStyleDisc}>
          <li>
            в&nbsp;2018 году «Халву»{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://finelita.ru/novosti/obyavleny-laureaty-xiv-premii-finansovaya-elita-rossii-2018.html"
            >
              признали
            </AppLink>{" "}
            лучшей банковской картой года, лауреат премии «Финансовая элита России»;
          </li>
          <li>
            по&nbsp;итогам 2024&nbsp;года банк{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.banki.ru/services/responses/?date=2024"
            >
              возглавил
            </AppLink>{" "}
            «Народный рейтинг» портала «
            <AppLink rel="nofollow noopener noreferrer" target="_blank" href="http://banki.ru">
              Банки.ру
            </AppLink>
            », а&nbsp;до&nbsp;2022{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://scb.ru/articles/novosti-kompanii/sovkombank-priznan-pobeditelem-narodnogo-reitinga-banki-ru-po-itogam-2022-goda"
            >
              занимал
            </AppLink>{" "}
            в&nbsp;нем первое место четыре года подряд;
          </li>
          <li>
            в 2024 году Совкомбанк первый в&nbsp;
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru/banki/rating/karty/"
            >
              рейтинге
            </AppLink>{" "}
            кредитных карт России по&nbsp;версии{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru"
            >
              «Сравни»
            </AppLink>{" "}
            (⭑4.91/5.00).
          </li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Что такое подписка «Халва.Десятка»?</p>,
      <div className={styles.listAnswer}>
        Это платная услуга, с&nbsp;которой вы получаете дополнительные преимущества:
        <ul className={styles.listStyleDisc}>
          <li>
            <b>10 месяцев рассрочки на&nbsp;покупки.*</b> Единый увеличенный срок рассрочки*
            в&nbsp;260&nbsp;000{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/shops/special"
            >
              магазинах-партнёрах
            </AppLink>{" "}
            Халвы*;
          </li>
          <li>
            <b>
              Удвоение{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/document?id=2777"
              >
                кэшбэка
              </AppLink>
              .
            </b>{" "}
            В 2 раза больше кэшбэка за&nbsp;каждую покупку или поездку на Яндекс GO – возвращайте
            до&nbsp;10% от&nbsp;стоимости;
          </li>
          <li>
            <b>Увеличенный лимит кешбэка в месяц 5 000.</b> Получайте больше кешбэка по карте**
          </li>
          <li>
            <b>+5% к&nbsp;ставке вкладов.</b> Увеличение*** на&nbsp;+5% по&nbsp;вкладам
            на&nbsp;сроке 36&nbsp;мес., +2% на&nbsp;сроке 24&nbsp;мес. (+1% на&nbsp;других сроках)
            при ежемесячном выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
            от&nbsp;20&nbsp;000&nbsp;₽.****;
          </li>
          <li>
            <b>+1% к ставке Онлайн-копилки.</b> Увеличение базовой ставки****;
          </li>
          <li>
            <b>+1 месяц рассрочки*.</b> На снятия, переводы и&nbsp;покупки заёмными средствами
            не&nbsp;у&nbsp;партнеров;
          </li>
          <li>
            <b>Бесплатный стикер Рау.</b> Для удобной оплаты телефоном и&nbsp;повышенного кэшбэка;
          </li>
          <li>
            <b>Комплексная IT-защита.</b> Онлайн-консультация эксперта при неисправностях и сбоях в
            работе компьютера или смартфона;
          </li>
          <li>
            <b>Помощник по покупкам.</b> Личный консультант подберет для вас нужный товар с лучшей
            ценой и сроком рассрочки*;
          </li>
          <li>
            <b>Страхование жизни и&nbsp;здоровья.</b> Выплаты при несчастном случае
            или&nbsp;болезни;
          </li>
          <li>
            <b>Страхование покупок.</b> Возмещение при&nbsp;повреждении или&nbsp;поломке важных
            покупок, а&nbsp;также юридическая помощь по&nbsp;правам покупателей;
          </li>
        </ul>
        <p>
          * Если базовый срок рассрочки* партнёра превышает 10&nbsp;месяцев, то к&nbsp;покупке
          применяется базовый срок.
        </p>
        <p>** Без подписки «Халва.Десятка» 3 000 баллов.</p>
        <p>
          *** Ставка повышается в&nbsp;конце срока и&nbsp;начисляется на&nbsp;общую сумму вкладов
          в&nbsp;банке до&nbsp;1,5 млн ₽.
        </p>
        <p>
          **** По впервые открытым копилкам увеличенная базовая ставка начисляется первые 3 месяца
          на&nbsp;сумму свыше 1,5&nbsp;млн&nbsp;руб., с&nbsp;4-го месяца и&nbsp;по&nbsp;повторно
          открытым копилкам — на&nbsp;любую сумму.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Сколько времени рассматривают заявку на&nbsp;Халву?</p>,
      <div className={styles.listAnswer}>
        Вы получите решение через несколько минут после того, как&nbsp;отправите заявку.
        В&nbsp;редких случаях на&nbsp;это может потребоваться 1 рабочий день.
      </div>,
    ],
  ],
  zaimy: [
    [
      <p className={styles.listQuestion}>Что такое займ?</p>,
      <div className={styles.listAnswer}>
        <p>
          Займ — вид отношений, при котором заимодавец на время или на определенных условиях
          передает в пользование заемщику деньги, ценные бумаги или имущество. Оформляется займ в
          виде договора (без письменного его заключения можно получить до 10 000 рублей, но только
          если в долг дает гражданин, а не организация).
        </p>
        <br />
        <p>
          Займы бывают безвозмездными (беспроцентными) или возмездными (когда за пользование
          заемными деньгами или имуществом нужно платить). Второй вариант — по сути тот же кредит.
          Отличие заключается в том, что кредиты могут выдавать только кредитные организации (их
          лицензирует Центральный банк РФ), а взаймы может дать практически кто угодно.
        </p>
        <br />
        <p>
          Однако если заимодавец заключает такие договоры постоянно и это его источник дохода
          (например, так работают микрофинансовые организации), то он также обязан выполнять ряд
          требований Центробанка. Все МФО включены в реестр Банка России.
        </p>
        <br />
        <p>Займы, как и кредиты, бывают:</p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>
              краткосрочные (МФО выдает небольшие суммы даже на несколько дней) и долгосрочные (в
              среднем от полугода до двух);
            </li>
            <li>
              в виде наличных, перевода или денег на карте (онлайн-перевод на персональный счет,
              кредитка или карта беспроцентной рассрочки*, займ в виде оплаты товаров в магазине).
            </li>
          </ul>
        </div>
        <p>Получить денежные средства взаймы можно как на руки наличными, так и онлайн.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Может ли займ быть беспроцентным?</p>,
      <div className={styles.listAnswer}>
        <p>
          Займ, в отличие от кредита, может быть бесплатным и беспроцентным. Например, если вы
          занимаете у знакомых, они могут одолжить определенную сумму с условием вернуть в срок
          аналогичную, без переплат.
        </p>
        <br />
        <p>
          Беспроцентные займы в банках или магазинах называются рассрочкой* (бывают в виде карт или
          денег, которые за ваши покупки банк перечисляет на счет продавца).
        </p>
        <br />
        <p>
          МФО беспроцентные займы не выдают практически никогда. У них нет широкого ассортимента
          продуктов, в отличие от банков. Основной доход эти организации получают как раз в виде
          высоких процентов по займам.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>На каких условиях предоставляется заем без процентов?</p>,
      <div className={styles.listAnswer}>
        <p>Чаще всего банки предоставляют беспроцентные займы на стандартных условиях:</p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>
              заемщик должен соответствовать ряду требований (иметь гражданство РФ, регистрацию на
              территории страны, источники дохода и так далее).
            </li>
            <li>долг нужно гасить равными частями на протяжении всего срока;</li>
            <li>просрочки не допускаются.</li>
          </ul>
        </div>
        <p>
          Требований у банков может быть несколько больше, чем в МФО, однако шансы получить деньги
          или товары в рассрочку* без переплат здесь значительно выше, чем в микрофинансовых
          организациях.
        </p>
        <br />
        <p>А штрафы за просрочку, если вы все же допустили ее, — значительно ниже.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какие документы нужны для получения займа?</p>,
      <div className={styles.listAnswer}>
        <p>
          Для получения займа в банке обычно нужны один-два документа. Дополнительные могут
          потребовать, например, если речь идет о крупных суммах.
        </p>
        <br />
        <p>
          Карту рассрочки* можно получить, имея при себе только паспорт гражданина РФ. Часто
          достаточно одного этого документа.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как получить займ без процентов?</p>,
      <div className={styles.listAnswer}>
        <p>
          Беспроцентные займы банки выдают в виде рассрочки*. Обычно такой формат не предусматривает
          скрытых комиссий или дополнительных условий (например, что без процентов деньгами можно
          пользоваться только несколько дней, что часто подразумевают под «бесплатными займами» в
          МФО).
        </p>
        <br />
        <p>
          Рассрочку* можно оформить в магазине при покупке товаров, а можно получить карту с лимитом
          заемных средств и пользоваться ею по мере необходимости.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какие есть плюсы и минусы у займов?</p>,
      <div className={styles.listAnswer}>
        <p>Плюсы и минусы зависят от того, где и на каких условиях вы берете конкретный займ.</p>
        <br />
        <p>
          Если это договор с МФО, то плюсом могут быть сниженные требования по отношению к заемщику
          по сравнению с теми, которые предъявляет банк. Но его полностью перекрывает большой минус
          — высокие процентные ставки. В среднем от 1—2% в день для краткосрочных обязательств
          (365—730% годовых). Это в разы выше ставок по любым банковским кредитам.
        </p>
        <br />
        <p>
          Плюсы рассрочки* от банка — отсутствие переплат, длительный срок займа (например, для
          Халвы — до 10 месяцев). Минусы — тратить деньги выгоднее у партнеров кредитной
          организации. Помимо стандартных льготных условий партнеры часто проводят акции и закрытые
          распродажи для держателей таких карт, тогда как сторонние организации в сотрудничестве не
          заинтересованы и льготы не предоставляют.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какие есть способы получения займа?</p>,
      <div className={styles.listAnswer}>
        <p>
          Займ в Совкомбанке выдается в виде возобновляемого кредитного лимита на карту «Халва».
          Получить можно до 500 000 рублей под 0% годовых на весь льготный период (до 10 месяцев).
        </p>
        <br />
        <p>Оформить карту можно онлайн:</p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>подать заявку в пару кликов;</li>
            <li>дождаться одобрения;</li>
            <li>
              забрать пластик в одном из отделений банка или заказать бесплатную доставку курьером.
            </li>
          </ul>
        </div>
        <p>
          Договор будет без скрытых комиссий и переплат, условия в нем простые и понятные, а
          получение денежных средств — удобное и быстрое.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Кaк будут нaчиcлятьcя пpoцeнты в cлучae, ecли зaйм нe будeт пoгaшeн в cpoк?
      </p>,
      <div className={styles.listAnswer}>
        <p>
          Полностью бесплатной рассрочка* будет только в том случае, если заемщик не нарушает
          условия договора.
        </p>
        <br />
        <p>
          На то, чтобы внести ежемесячный платеж, у него есть 15 дней. Если возникли трудности и
          размер взноса стал некомфортным, за небольшую комиссию (3,9% от суммы долга) можно
          подключить услугу «Минимальный платеж» и ежемесячно платить 1/20 суммы задолженности.
        </p>
        <br />
        <p>
          Если этот вариант не подошел и образовалась просрочка, банк будет начислять комиссию в
          виде 20% годовых на сумму задолженности каждый день до внесения платежа.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Почему займ выгоднее оформлять в банке?</p>,
      <div className={styles.listAnswer}>
        <p>
          Несмотря на то что в микрофинансовых организациях получить деньги проще, чем в банке, это
          куда менее выгодно. Сроки микрозаймов проходят мгновенно, а при ставке 1—2% в день (это
          365—730% годовых) задолженность растет стремительно и погасить такую — непосильная для
          многих задача.
        </p>
        <br />
        <p>
          В банке можно получить деньги под низкий годовой процент или бесплатно, а льготный период
          рассрочки* — до 10 месяцев.
        </p>
        <br />
        <p>Условий для получения не много:</p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>гражданство РФ (паспорт и регистрация);</li>
            <li>стабильный источник дохода;</li>
            <li>не испорченная или исправленная кредитная история.</li>
          </ul>
        </div>
        <p>
          Банки надежнее МФО, потому что их деятельность строго регламентирована, а положительная
          репутация зарабатывается годами.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как узнать доступную сумму займа?</p>,
      <div className={styles.listAnswer}>
        <p>
          На Халве заемный лимит может достигать 500 000 рублей. Первоначальная сумма, которую
          одобряют после рассмотрения заявки, как правило, ниже. Но ее можно постепенно увеличить,
          если активно пользоваться картой и не допускать просрочек.
        </p>
        <br />
        <p>
          Доступную сумму займа можно проверить в приложении. Информация по заемным средствам, в том
          числе и баланс кредитного счета, отображается в разделе «Карта Халва». Там же можно
          переключаться между счетами, настраивать режимы использования денежных средств.
        </p>
      </div>,
    ],
  ],
  tgCashback: [
    [
      <p className={styles.listQuestion}>Халва – кредитная или&nbsp;дебетовая карта?</p>,
      <div className={styles.listAnswer}>
        Халва – универсальная карта, которую можно использовать одновременно как&nbsp;дебетовую
        и&nbsp;карту рассрочки*. Сменить режим можно легко в&nbsp;приложении
        «Халва&nbsp;–&nbsp;Совкомбанк».
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Какой минимальный и&nbsp;максимальный лимит рассрочки*?
      </p>,
      <div className={styles.listAnswer}>
        Минимальный лимит по карте «Халва» — 15 000 руб. Максимальный лимит составляет 500 000 руб.
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Влияет ли наличие карты на&nbsp;кредитную нагрузку?</p>,
      <div className={styles.listAnswer}>
        Поскольку с помощью Халвы вы покупаете товары в&nbsp;рассрочку*, наличие задолженности
        по&nbsp;карте влияет на&nbsp;кредитную нагрузку. Банк будет относиться к&nbsp;вам более
        лояльно, если вы будете активно пользоваться картой и&nbsp;своевременно вносить платежи.
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Насколько надежен банк, который выпускает карту? Где о&nbsp;нем можно узнать информацию?
      </p>,
      <div className={styles.listAnswer}>
        Халва — это проект Совкомбанка. Вся информация о его надежности — лицензии, реквизиты,
        рейтинги финансовой организации — собрана на&nbsp;
        <AppLink
          rel="nofollow noopener noreferrer"
          target="_blank"
          href="https://scb.ru/about/info"
        >
          отдельной странице
        </AppLink>
        .<br />
        <br /> Совкомбанк зарекомендовал себя как надежная организация и&nbsp;не&nbsp;раз лидировал
        в&nbsp;народных рейтингах:{" "}
        <ul className={styles.listStyleDisc}>
          <li>
            в&nbsp;2018 году «Халву»{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://finelita.ru/novosti/obyavleny-laureaty-xiv-premii-finansovaya-elita-rossii-2018.html"
            >
              признали
            </AppLink>{" "}
            лучшей банковской картой года, лауреат премии «Финансовая элита России»;
          </li>
          <li>
            по&nbsp;итогам 2024 года банк{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.banki.ru/services/responses/?date=2024"
            >
              возглавил
            </AppLink>{" "}
            «Народный рейтинг» портала{" "}
            <AppLink rel="nofollow noopener noreferrer" target="_blank" href="http://banki.ru">
              «Банки.ру»
            </AppLink>
            , а&nbsp;до&nbsp;2022{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://scb.ru/articles/novosti-kompanii/sovkombank-priznan-pobeditelem-narodnogo-reitinga-banki-ru-po-itogam-2022-goda"
            >
              занимал
            </AppLink>{" "}
            в&nbsp;нем первое место четыре года подряд;
          </li>
          <li>
            в&nbsp;2024 году Совкомбанк первый в&nbsp;
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru/banki/rating/karty/"
            >
              рейтинге
            </AppLink>{" "}
            кредитных карт России по&nbsp;версии{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://www.sravni.ru"
            >
              «Сравни»
            </AppLink>{" "}
            (⭑4.91/5.00).
          </li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Что такое подписка «Халва.Десятка»?</p>,
      <div className={styles.listAnswer}>
        Это платная услуга, с&nbsp;которой вы получаете дополнительные преимущества:
        <ul className={styles.listStyleDisc}>
          <li>
            <b>10 месяцев рассрочки на&nbsp;покупки.*</b> Единый увеличенный срок рассрочки*
            в&nbsp;260&nbsp;000{" "}
            <AppLink
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://halvacard.ru/shops/special"
            >
              магазинах-партнёрах
            </AppLink>{" "}
            Халвы*;
          </li>
          <li>
            <b>
              Удвоение{" "}
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/document?id=2777"
              >
                кэшбэка
              </AppLink>
              .
            </b>{" "}
            В 2 раза больше кэшбэка за&nbsp;каждую покупку или поездку на Яндекс GO – возвращайте
            до&nbsp;10% от&nbsp;стоимости;
          </li>
          <li>
            <b>Увеличенный лимит кешбэка в месяц 5 000.</b> Получайте больше кешбэка по карте**
          </li>
          <li>
            <b>+5% к&nbsp;ставке вкладов.</b> Увеличение*** на&nbsp;+5% по&nbsp;вкладам
            на&nbsp;сроке 36&nbsp;мес., +2% на&nbsp;сроке 24&nbsp;мес. (+1% на&nbsp;других сроках)
            при ежемесячном выполнении условия: от&nbsp;10 покупок по&nbsp;Халве на&nbsp;общую сумму
            от&nbsp;20&nbsp;000&nbsp;₽.****;
          </li>
          <li>
            <b>+1% к ставке Онлайн-копилки.</b> Увеличение базовой ставки****;
          </li>
          <li>
            <b>+1 месяц рассрочки*.</b> На снятия, переводы и&nbsp;покупки заёмными средствами
            не&nbsp;у&nbsp;партнеров;
          </li>
          <li>
            <b>Бесплатный стикер Рау.</b> Для удобной оплаты телефоном и&nbsp;повышенного кэшбэка;
          </li>
          <li>
            <b>Комплексная IT-защита.</b> Онлайн-консультация эксперта при неисправностях и сбоях в
            работе компьютера или смартфона;
          </li>
          <li>
            <b>Помощник по покупкам.</b> Личный консультант подберет для вас нужный товар с лучшей
            ценой и сроком рассрочки*;
          </li>
          <li>
            <b>Страхование жизни и&nbsp;здоровья.</b> Выплаты при несчастном случае
            или&nbsp;болезни;
          </li>
          <li>
            <b>Страхование покупок.</b> Возмещение при&nbsp;повреждении или&nbsp;поломке важных
            покупок, а&nbsp;также юридическая помощь по&nbsp;правам покупателей;
          </li>
        </ul>
        <p>
          * Если базовый срок рассрочки* партнёра превышает 10&nbsp;месяцев, то к&nbsp;покупке
          применяется базовый срок.
        </p>
        <p>** Без подписки «Халва.Десятка» 3 000 баллов.</p>
        <p>
          *** Ставка повышается в&nbsp;конце срока и&nbsp;начисляется на&nbsp;общую сумму вкладов
          в&nbsp;банке до&nbsp;1,5 млн ₽.
        </p>
        <p>
          **** По впервые открытым копилкам увеличенная базовая ставка начисляется первые 3 месяца
          на&nbsp;сумму свыше 1,5&nbsp;млн&nbsp;руб., с&nbsp;4-го месяца и&nbsp;по&nbsp;повторно
          открытым копилкам — на&nbsp;любую сумму.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Сколько времени рассматривают заявку на&nbsp;Халву?</p>,
      <div className={styles.listAnswer}>
        Вы получите решение через несколько минут после того, как&nbsp;отправите заявку.
        В&nbsp;редких случаях на&nbsp;это может потребоваться 1 рабочий день.
      </div>,
    ],
  ],
  debet: [
    [
      <p className={styles.listQuestion}>Что такое дебетовая карта?</p>,
      <div className={styles.listAnswer}>
        <p>
          Простыми словами — это карта, на которой лежат деньги с вашего банковского счета. Это
          прямой доступ к вашим средствам, и вы сами решаете, как поступить с картой: расплачиваться
          ею на кассе, снимать наличные в банкомате, оформлять онлайн-платежи, переводить кому-то
          деньги на другую дебетовку, принимать переводы, получать пенсию или зарплату и т. д.
        </p>
        <br />
        <p>
          Она действует по принципу вашего кошелька. Пока у вас есть собственные деньги, вы можете
          ею расплачиваться.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Халва – это дебетовая карта?</p>,
      <div className={styles.listAnswer}>
        <p>
          Нет. Халва — это инструмент рассрочки*. Но у нее есть и функции дебетовки. Что это значит?
        </p>
        <br />
        <p>
          Вы можете хранить на ней личные средства, оплачивать ими покупки на кассе и онлайн,
          зарабатывать кэшбэк, проценты на остаток, принимать и отправлять другим денежные переводы
          и т. д.
        </p>
        <br />
        <p>
          Иными словами, она никак не уступает дебетовке. А наоборот, превосходит ее по
          возможностям.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>В чем отличие карты рассрочки* от дебетовой карты?</p>,
      <div className={styles.listAnswer}>
        <p>
          У карт рассрочек* есть лимит заемных средств. У Халвы эта сумма достигает 500 тысяч
          рублей. Их можно использовать в любом магазине-партнере, а процесс оплаты почти ничем не
          отличается.
        </p>
        <br />
        <p>
          Если вы хотите «одолжить» у банка, то в приложении нужно включить режим использования
          заемных, а затем купить товар как обычно.
        </p>
        <br />
        <p>
          Дебетовый «пластик» не может похвастаться такой возможностью. Это значительно расширяет
          функции Халвы. Да и получить вознаграждение в виде кэшбэка с трат заемных средств приятно
          вдвойне!
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как заказать дебетовую карту?</p>,
      <div className={styles.listAnswer}>
        <p>
          Как правило, для получения дебетовой нужен только паспорт. Сотрудник банка сделает копию
          основных личных данных будущего клиента.
        </p>
        <br />
        <p>
          Для Халвы действуют точно такие же условия: предъявление паспорта. Заказать ее можно на
          сайте — не нужно никуда ездить.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какой срок действия у банковской карты?</p>,
      <div className={styles.listAnswer}>
        <p>
          В зависимости от банка срок действия дебетового «пластика» может варьироваться от 2 до 5
          лет. В среднем он составляет 3 года.
        </p>
        <br />
        <p>
          У Халвы срок действия увеличенный — 7 лет, по истечении которых ее перевыпускают
          бесплатно.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какие есть плюсы и минусы у дебетовой карты?</p>,
      <div className={styles.listAnswer}>
        <p>У дебетовки, как и у Халвы, есть множество схожих плюсов, например:</p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>постоянный доступ владельца к собственным средствам;</li>
            <li>оформление только по паспорту;</li>
            <li>быстрая оплата «пластиком» в одно касание;</li>
            <li>возможность заказать карту удаленно;</li>
            <li>мгновенные переводы денег с карты на карту;</li>
            <li>возможность создать виртуальный аналог;</li>
            <li>кэшбэк за покупки;</li>
            <li>удобство использования интернет-банкингом.</li>
          </ul>
          <br />
          <p>Когда дело доходит до минусов, то дебетовка уступает.</p>
          <br />
          <ul>
            <li>Средства ограничены.</li>
          </ul>
          <p>
            Иными словами, сколько у вас есть, столько вы и потратите. С нулевым балансом дебетовая
            карточка — просто кусок пластика.
          </p>
          <br />
          <p>
            У обладателей карт рассрочки* есть возможность совершать покупки, используя заемные
            деньги. Это подводит нас к следующему пункту.
          </p>
          <br />
          <ul>
            <li>Нет лимита заемных средств.</li>
          </ul>
          <p>
            Когда нужно купить что-то дорогое, людям, как правило, приходится копить, занимать у
            знакомых или идти за кредитом. Это в том случае, если не хватает собственных денег.
          </p>
          <br />
          <p>Но с Халвой такая потребность отпадает.</p>
          <br />
          <p>
            Если жизнь подкинула вам экстренные траты, то вы можете оформить рассрочку* по Халве,
            включив режим оплаты заемными средствами. У дебетовок такая функция отсутствует.
          </p>
          <br />
          <ul>
            <li>Небольшой срок действия.</li>
          </ul>
          <p>В среднем срок действия дебетовок — 3 года.</p>
          <br />
          <p>
            У Халвы этот срок — 7 лет. По истечении этого времени ее бесплатно перевыпустят и
            доставят курьером.
          </p>
          <br />
          <ul>
            <li>Долгое изготовление.</li>
          </ul>
          <p>
            Создание дебетовки занимает несколько дней. Это неудобно, если она нужна здесь и сейчас.
          </p>
          <br />
          <p>Карту рассрочки* вы получите уже в день подачи заявки.</p>
          <br />
          <ul>
            <li>Плата за обслуживание и перевыпуск.</li>
          </ul>
          <p>
            Как правило, за пользование дебетовкой и перевыпуск (например, при утере) приходится
            платить.
          </p>
          <br />
          <p>У Халвы бесплатные обслуживание и перевыпуск — даже внеплановый.</p>
        </div>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как закрыть банковскую карту?</p>,
      <div className={styles.listAnswer}>
        <p>
          Закрыть ее можно в любой момент. Эта функция есть в приложении вашего банка. Достаточно
          нажать пару кнопок, и она перестанет действовать.
        </p>
        <br />
        <p>
          Важно понимать, что «пластик» — это только способ доступа к вашему банковскому счету.
          Поэтому деактивация первого не то же самое, что закрытие счета. Вы все еще можете свободно
          им пользоваться и хранить на нем средства. Чтобы закрыть и его, нужно обращаться в
          отделение банка.
        </p>
      </div>,
    ],
  ],
  credit: [
    [
      <p className={styles.listQuestion}>Какая кредитная ставка по Халве?</p>,
      <div className={styles.listAnswer}>
        <p>
          Можете забыть об этом термине, это не кредитная карта. С нашей картой вам доступна
          рассрочка*. За нее платить не нужно, эти расходы ложатся на магазины-партнеры банка.
        </p>
        <br />
        <p>
          На практике это выглядит так: вы расплачиваетесь у одного из партнеров заемными деньгами.
          Никаких дополнительных договоров заключать не нужно.
        </p>
        <br />
        <p>
          Сумма автоматически разбивается на равные платежи с графиком погашения на срок до десяти
          месяцев.
        </p>
        <br />
        <p>
          Раз в 30 дней пополняйте баланс, чтобы без переплат в комфортном темпе погасить
          задолженность.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>«Халва» – это кредитная карта?</p>,
      <div className={styles.listAnswer}>
        <p>
          Эта карточка универсальна. Она не кредитная карта, а рассрочки*. Оплачивайте у партнеров
          заказы в онлайн- и офлайн-магазинах деньгами банка. Снимайте деньги в долг на срок до трех
          месяцев.
        </p>
        <br />
        <p>
          Лимит рассрочки* нужен для подстраховки, и в повседневной жизни вы пользуетесь им редко?
          Храните на Халве собственные рубли (пользуйтесь как обычной дебетовой картой) и получайте
          процент на оставшиеся деньги. А если оплачиваете своими деньгами товары и услуги в
          магазинах-партнерах, часть потраченных средств вернется баллами кэшбэка.
        </p>
        <br />
        <p>
          Переключайтесь между кредитным и дебетовым счетами одним нажатием в личном кабинете на
          сайте банка или в приложении «Халва — Совкомбанк». Интернет-банк удобен тем, что все
          сервисы доступны онлайн.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>В чем отличие карты рассрочки* от кредитной карты?</p>,
      <div className={styles.listAnswer}>
        <p>
          Кредитная карта — пластиковый кошелек с кредитным лимитом. Тратить деньги можно на любые
          цели. Чтобы погасить долг без переплат, у заемщика есть льготный период (грейс-период).
          Обычно это срок в три-четыре месяца.
        </p>
        <br />
        <p>
          Если вы не успеваете вернуть долг до окончания беспроцентного периода, на сумму кредита
          начисляются проценты по ставке 30–60% годовых (в зависимости от банка). Долг сразу
          становится значительно больше.
        </p>
        <br />
        <p>
          Рассрочка* работает по-другому: вы оплачиваете покупку, а магазин-партнер компенсирует
          банку сумму за использование заемных средств. Стоимость покупки нужно вернуть в срок до
          десяти месяцев, что гораздо комфортнее рамок кредитного лимита. Никаких переплат.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>В чем суть карты рассрочки*?</p>,
      <div className={styles.listAnswer}>
        <p>
          Она дает возможность оплачивать услуги и покупать товары у партнеров банка заемными
          средствами без переплат. Пополняйте вовремя баланс на сумму ежемесячного платежа, тогда
          такой заем не потребует оплаты.
        </p>
        <br />
        <p>
          В отличие от бесплатного периода по кредитной карте, рассрочка* оформляется на более
          долгий срок (до десяти месяцев у Халвы).
        </p>
        <br />
        <p>
          Покупаете телевизор за 50 000 рублей в рассрочку* на пять месяцев. Ежемесячно возвращаете
          на карту 10 000 рублей, и по истечении срока задолженность закрывается. Ничего сверх 50
          000 рублей доплачивать не нужно. В таком формате вы пользуетесь деньгами банка бесплатно.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Влияет ли наличие карты на кредитную нагрузку?</p>,
      <div className={styles.listAnswer}>
        <p>
          Когда вы покупаете что-то в рассрочку*, появляется задолженность. Ее, как и в случае со
          всеми подобными финансовыми услугами, учитывают при расчете кредитной нагрузки и вносят в
          кредитную историю.
        </p>
        <br />
        <p>
          Воспользуйтесь этим для создания репутации надежного заемщика с хорошей кредитной
          историей. Покупайте иногда товары в рассрочку* и вовремя пополняйте баланс, погашая долг.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Кредитный лимит и лимит рассрочки* – одно и то же?</p>,
      <div className={styles.listAnswer}>
        <p>
          Деньги банка — заемные. Они доступны и по кредиту, и по рассрочке*. Их можно тратить на
          свои нужды. Но есть разница.
        </p>
        <br />
        <p>
          Деньги с кредитной карты часто используют для оплаты небольших покупок, потому что
          проценты по такому займу будут начисляться, как только кончится короткий льготный период.
          Не рассчитаете финансовую нагрузку, и долг сразу станет значительно больше.
        </p>
        <br />
        <p>Зато потратить кредитные средства заемщик может на что угодно.</p>
        <br />
        <p>
          Деньги рассрочки* можно тратить на покупки в любых магазинах, но выгоднее это делать у
          партнеров банка. У Халвы их более 260 000.
        </p>
        <br />
        <p>
          Возвращать заемные средства проще. Сумму можно разбить на ежемесячные платежи (на срок до
          десяти месяцев). Поэтому с Халвой удобно без переплат покупать, например дорогостоящую
          технику.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какой минимальный и максимальный кредитный лимит?</p>,
      <div className={styles.listAnswer}>
        <p>
          На балансе Халвы может быть от 15 000 рублей заемных средств. Но количество доступных
          средств бывает и значительно больше. Максимум — 500 000 рублей.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как увеличить лимит рассрочки* на карте «Халва»?</p>,
      <div className={styles.listAnswer}>
        <p>
          Доступный размер рассрочки* растет постепенно. Чтобы его увеличивать, нужно несколько раз
          в месяц (от десяти) оплачивать пластиком любые услуги и товары и потратить на это в сумме
          от 20 000 ₽.
        </p>
        <br />
        <p>
          Необязательно тратить заемные деньги. Пользуйтесь Халвой как дебетовой картой,
          распоряжаясь своими рублями. Этого достаточно, чтобы сумму рассрочки* можно было со
          временем увеличить.
        </p>
        <br />
        <p>
          Вы можете переключиться с режима траты заемных средств на свои. Для этого нужно лишь
          открыть приложение и внести нужное изменение.
        </p>
        <br />
        <p>
          Также вы можете совершать денежные переводы своим родным и друзьям на карты других банков
          или по СБП.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Что будет, если просрочить ежемесячный платеж?</p>,
      <div className={styles.listAnswer}>
        <p>
          При просрочке от одного до пяти дней никаких санкций не предусмотрено. С шестого дня
          просрочки будут начислять 0,1 % от суммы просроченной задолженности за каждый день
          нарушения обязательств.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Когда и как списывается ежемесячный платеж?</p>,
      <div className={styles.listAnswer}>
        <p>
          Погашать задолженность на Халве легко. Достаточно пополнять баланс на сумму ежемесячного
          платежа и в одно нажатие направлять деньги на уменьшение долга. Или еще проще: настроить
          автоматическое списание с карты. В таком случае останется только контролировать, чтобы
          денег на счете хватало для взноса.
        </p>
        <br />
        <p>За графиком можно следить на сайте банка или в приложении «Халва — Совкомбанк».</p>
        <br />
        <p>Платеж начисляется с учетом двух периодов: расчетного и платежного.</p>
        <br />
        <p>
          Первый начинается со дня, когда вы заключили договор, и обновляется раз в месяц (например,
          по договору от 18 апреля это будет период с 18 числа одного месяца до 18 числа
          следующего). В этот срок вы можете оформить несколько рассрочек*. Первый общий платеж по
          ним нужно будет внести в течение 15 дней после завершения расчетного периода.
        </p>
        <br />
        <p>Платежный период — 15 дней со дня завершения расчетного.</p>
      </div>,
    ],
  ],
  refin: [
    [
      <p className={styles.listQuestion}>Что такое рефинансирование?</p>,
      <div className={styles.listAnswer}>
        <p>
          Рефинансирование — оформление нового кредита, с помощью которого закрывают действующий
          заем. Услуга помогает снизить финансовую нагрузку, объединить несколько задолженностей в
          одну, получить более выгодные условия.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как рефинансировать кредитные карты?</p>,
      <div className={styles.listAnswer}>
        <p>
          С картой «Халва» можно рефинансировать долг по кредитке до 300 000 рублей. Банк погасит
          заем и разделит сумму кредита на равные платежи, которые клиент будет вносить в течение
          нескольких месяцев. Срок зависит от нескольких условий:
        </p>
        <br />
        <ul>
          <li>
            — <b>24 месяца</b> — при оплате Халвой от десяти покупок в месяц на общую сумму не
            меньше 20 000 ₽ в течение всего срока;
          </li>
          <li>
            — <b>10 месяцев</b> — если не удалось выполнить требование по минимальному обороту при
            наличии подписки «Халва.Десятка». Новый срок начинает действовать с момента нарушения
            условия;
          </li>
          <li>
            — <b>6 месяцев</b> — если не удалось выполнить требование по минимальному обороту без
            подписки. Новый срок начинает действовать с момента нарушения условия.
          </li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Карты каких банков я могу закрыть с помощью рефинансирования с Халвой?
      </p>,
      <div className={styles.listAnswer}>
        <p>Предложение действительно для кредитных карт любых российских банков.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Что будет, если просрочить ежемесячный платеж?</p>,
      <div className={styles.listAnswer}>
        <p>
          При просрочке от одного до пяти дней никаких санкций не предусмотрено. С шестого дня
          просрочки будут начислять 0,1 % от суммы просроченной задолженности за каждый день
          нарушения обязательств.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Когда и как списывается ежемесячный платеж?</p>,
      <div className={styles.listAnswer}>
        <p>
          Ежемесячный платеж списывают в течение платежного периода. Он составляет 15 дней и зависит
          от даты открытия Халвы. При наличии собственных средств на карте списание происходит
          автоматически.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Когда я погашу задолженность, карта «Халва» будет больше не нужна?
      </p>,
      <div className={styles.listAnswer}>
        <p>
          Карта «Халва» — универсальный банковский продукт, который сочетает в себе множество
          выгодных преимуществ. С помощью нее можно совершать покупки в рассрочку*, получать кэшбэк,
          осуществлять платежи и переводы, откладывать деньги на крупные покупки и многое другое!
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Можно будет снова воспользоваться кредитными средствами после погашения задолженности по
        рефинансированию?
      </p>,
      <div className={styles.listAnswer}>
        <p>
          Заемный лимит по Халве возобновляемый. После погашения задолженности вы сможете
          воспользоваться им снова для рефинансирования других кредитных карт и оплаты товаров и
          услуг в рассрочку*.
        </p>
      </div>,
    ],
  ],
  pkwRefin: [
    [
      <p className={styles.listQuestion}>Что такое рефинансирование?</p>,
      <div className={styles.listAnswer}>
        <p>
          Рефинансирование — оформление нового кредита, с&nbsp;помощью которого закрывают
          действующий кредит. Услуга помогает снизить финансовую нагрузку, объединить несколько
          задолженностей в&nbsp;одну, получить более выгодные условия.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как рефинансировать кредитные карты?</p>,
      <div className={styles.listAnswer}>
        <p>
          С картой «Халва» можно рефинансировать долг по&nbsp;кредитке
          до&nbsp;300&nbsp;000&nbsp;рублей. Банк погасит кредит и&nbsp;разделит сумму кредита
          на&nbsp;равные платежи, которые клиент будет вносить в&nbsp;течение нескольких месяцев.
          Срок зависит от&nbsp;нескольких условий:
        </p>
        <br />
        <ul>
          <li>
            — <b>24 месяца</b> — при оплате Халвой от десяти покупок в месяц на общую сумму не
            меньше 20 000 ₽ в течение всего срока;
          </li>
          <li>
            — <b>10 месяцев</b> — если не удалось выполнить требование по минимальному обороту при
            наличии подписки «Халва.Десятка». Новый срок начинает действовать с момента нарушения
            условия;
          </li>
          <li>
            — <b>6 месяцев</b> — если не удалось выполнить требование по минимальному обороту без
            подписки. Новый срок начинает действовать с момента нарушения условия.
          </li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Карты каких банков я могу закрыть с помощью рефинансирования с Халвой?
      </p>,
      <div className={styles.listAnswer}>
        <p>Предложение действительно для кредитных карт любых российских банков.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Что будет, если просрочить ежемесячный платеж?</p>,
      <div className={styles.listAnswer}>
        <p>
          При просрочке от одного до пяти дней никаких санкций не предусмотрено. С шестого дня
          просрочки будут начислять 0,1 % от суммы просроченной задолженности за каждый день
          нарушения обязательств.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Когда и как списывается ежемесячный платеж?</p>,
      <div className={styles.listAnswer}>
        <p>
          Ежемесячный платеж списывают в течение платежного периода. Он составляет 15 дней и зависит
          от даты открытия Халвы. При наличии собственных средств на карте списание происходит
          автоматически.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Когда я погашу задолженность, карта «Халва» будет больше не нужна?
      </p>,
      <div className={styles.listAnswer}>
        <p>
          Карта «Халва» — универсальный банковский продукт, который сочетает в себе множество
          выгодных преимуществ. С помощью нее можно совершать покупки в рассрочку*, получать кэшбэк,
          осуществлять платежи и переводы, откладывать деньги на крупные покупки и многое другое!
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Можно будет снова воспользоваться кредитными средствами после погашения задолженности по
        рефинансированию?
      </p>,
      <div className={styles.listAnswer}>
        <p>
          Заемный лимит по Халве возобновляемый. После погашения задолженности вы сможете
          воспользоваться им снова для рефинансирования других кредитных карт и оплаты товаров и
          услуг в рассрочку*.
        </p>
      </div>,
    ],
  ],
  bezProcentov: [
    [
      <p className={styles.listQuestion}>Что такое карта рассрочки*?</p>,
      <div className={styles.listAnswer}>
        <p>
          Карта рассрочки* «Халва» — это пластиковое/виртуальное платежное средство. Какие операции
          с ней доступны:
        </p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>
              оплата товаров заемными средствами в беспроцентную рассрочку* в магазинах-партнерах;
            </li>
            <li>снятие наличных в рассрочку* на три месяца;</li>
            <li>использование в качестве дебетовой карты — хранение средств и оплата покупок;</li>
            <li>получение кэшбэка за оплаченные покупки;</li>
            <li>возможность откладывать деньги — открывать вклады и Онлайн-копилку.</li>
          </ul>
        </div>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как рефинансировать кредитные карты без процентов?</p>,
      <div className={styles.listAnswer}>
        <p>
          Рефинансирование — оформление нового кредита, с помощью которого закрывают действующий
          заем. Услуга помогает снизить финансовую нагрузку, объединить несколько задолженностей в
          одну, получить более выгодные условия.
        </p>
        <br />
        <p>
          С картой «Халва» можно рефинансировать долг по кредитке до 300 000 рублей в беспроцентную
          рассрочку*. Банк погасит заем и разделит сумму кредита на равные платежи, которые клиент
          будет вносить в течение нескольких месяцев. Срок зависит от нескольких условий:
        </p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>
              <strong>24 месяца</strong> — при оплате Халвой от десяти покупок в месяц на общую
              сумму не меньше 20 000 ₽ в течение всего срока;
            </li>
            <li>
              <strong>10 месяцев</strong> — если не удалось выполнить требование по минимальному
              обороту при наличии подписки «Халва.Десятка». Новый срок начинает действовать с
              момента нарушения условия;
            </li>
            <li>
              <strong>6 месяцев</strong> — если не удалось выполнить требование по минимальному
              обороту без подписки. Новый срок начинает действовать с момента нарушения условия.
            </li>
          </ul>
        </div>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Карты каких банков я могу закрыть с помощью рефинансирования с Халвой?
      </p>,
      <div className={styles.listAnswer}>
        <p>Предложение действительно для кредитных карт любых российских банков.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Что будет, если просрочить ежемесячный платеж? </p>,
      <div className={styles.listAnswer}>
        <p>
          При просрочке от одного до пяти дней никаких санкций не предусмотрено. С шестого дня
          просрочки будут начислять 0,1 % от суммы просроченной задолженности за каждый день
          нарушения обязательств.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Когда и как списывается ежемесячный платеж?</p>,
      <div className={styles.listAnswer}>
        <p>
          Ежемесячный платеж списывают в течение платежного периода. Он составляет 15 дней и зависит
          от даты открытия Халвы. При наличии собственных средств на карте списание происходит
          автоматически.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Когда я погашу задолженность, карта «Халва» будет больше не нужна?
      </p>,
      <div className={styles.listAnswer}>
        <p>
          Карта «Халва» — универсальный банковский продукт, который сочетает в себе множество
          выгодных преимуществ. С помощью нее можно совершать покупки в рассрочку*, получать кэшбэк
          и процент на остаток, осуществлять платежи и переводы, откладывать деньги на крупные
          покупки и многое другое!
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Можно будет снова воспользоваться кредитными средствами после погашения задолженности по
        рефинансированию?
      </p>,
      <div className={styles.listAnswer}>
        <br />

        <p>
          Заемный лимит по Халве возобновляемый. После погашения задолженности вы сможете
          воспользоваться им снова для рефинансирования других кредитных карт и оплаты товаров и
          услуг в рассрочку*.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Может ли студент оформить карту рассрочки*?</p>,
      <div className={styles.listAnswer}>
        <p>
          Студенты, достигшие 18 лет, вправе открыть карту рассрочки* «Халва» с возможностью
          использовать заемные средства. Для оформления карты потребуется паспорт гражданина РФ.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Какие документы нужно предоставить в банк для открытия карты?
      </p>,
      <div className={styles.listAnswer}>
        <p>В большинстве случаев Халву оформят по паспорту гражданина России.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Где можно оформить карту рассрочки* «Халва»?</p>,
      <div className={styles.listAnswer}>
        <p>
          Для этого предусмотрены два варианта: в ближайшем отделении банка или на сайте, отправив
          онлайн-заявку.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как разблокировать карту после блокировки владельцем?</p>,
      <div className={styles.listAnswer}>
        <p>
          Обратитесь в любое отделение банка, напишите оператору в чат мобильного приложения или
          позвоните по номеру 8 (800) 100-77-72.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Сколько времени банк хранит карту после ее выпуска?</p>,
      <div className={styles.listAnswer}>
        <p>
          Карту можно забрать в течение двух месяцев. Если после этого срока она останется
          невостребованной, ее уничтожат.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как узнать номер счета карты?</p>,
      <div className={styles.listAnswer}>
        <p>Номер счета можно найти в приложении:</p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>авторизуйтесь и выберите карту «Халва»;</li>
            <li>перейдите в раздел «Важно»;</li>
            <li>кликните по строчке «О карте».</li>
          </ul>
          <br />
          <p>
            Здесь собрана информация о номере счета, а также основные данные: номер карты и
            договора, срок действия, предоставленный лимит рассрочки*, наличие задолженности и т. д.
          </p>
        </div>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как узнать о готовности карты?</p>,
      <div className={styles.listAnswer}>
        <p>Вам поступит смс-сообщение или звонок от банковского сотрудника.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Меняются ли реквизиты карты при замене?</p>,
      <div className={styles.listAnswer}>
        <br />
        <div className={styles.htmlBlock}>
          <p>Это зависит от причины замены карты:</p>
          <ul>
            <li>плановой (истек срок действия) — реквизиты не меняют;</li>
            <li>
              внеплановой (в результате кражи или повреждения) — меняют номер, CVC/CVV-код и период
              действия. Банковские реквизиты остаются прежними
            </li>
          </ul>
        </div>
      </div>,
    ],
    [
      <p className={styles.listQuestion}> Где узнать условия по кэшбэку карты «Халва»?</p>,
      <div className={styles.listAnswer}>
        <p>
          Информация по получению кэшбэка собрана на официальном сайте Совкомбанка.
          <br />
          Данные по начисленному кэшбэку отражены в приложении «Халва — Совкомбанк».
        </p>
      </div>,
    ],
  ],
  procentyVernetMagazin: [
    [
      <p className={styles.listQuestion}>Что такое карта рассрочки*?</p>,
      <div className={styles.listAnswer}>
        <p>
          Карта рассрочки* «Халва» — это пластиковое/виртуальное платежное средство. Какие операции
          с ней доступны:
        </p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>
              оплата товаров заемными средствами в беспроцентную рассрочку* в магазинах-партнерах;
            </li>
            <li>
              снятие наличных в рассрочку* на три месяца, доступно только с подпиской, без нее на 2
              месяца;
            </li>
            <li>использование в качестве дебетовой карты — хранение средств и оплата покупок;</li>
            <li>получение кэшбэка за оплаченные покупки;</li>
            <li>возможность откладывать деньги — открывать вклады и Онлайн-копилку.</li>
          </ul>
        </div>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как рефинансировать кредитные карты?</p>,
      <div className={styles.listAnswer}>
        <p>
          Рефинансирование - предоставление увеличенного лимита кредитования по&nbsp;Халве,
          с&nbsp;помощью которого закрывают действующий кредит. Услуга помогает снизить финансовую
          нагрузку, объединить несколько задолженностей в&nbsp;одну.
        </p>
        <br />
        <p>
          С картой «Халва» можно рефинансировать долг по&nbsp;кредитке до&nbsp;300&nbsp;000 рублей
          в&nbsp;беспроцентную рассрочку*. Банк погасит кредит и&nbsp;разделит сумму кредита
          на&nbsp;равные платежи, которые клиент будет вносить в&nbsp;течение нескольких месяцев.
          Срок зависит от&nbsp;нескольких условий:
        </p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>
              <strong>24 месяца</strong> — при оплате Халвой от&nbsp;десяти покупок в&nbsp;месяц
              на&nbsp;общую сумму не меньше 20&nbsp;000 ₽ в&nbsp;течение всего срока;
            </li>
            <li>
              <strong>10 месяцев</strong> — если не&nbsp;удалось выполнить требование
              по&nbsp;минимальному обороту при наличии подписки «Халва.Десятка». Новый срок начинает
              действовать с&nbsp;момента нарушения условия;
            </li>
            <li>
              <strong>6 месяцев</strong> — если не&nbsp;удалось выполнить требование
              по&nbsp;минимальному обороту без подписки. Новый срок начинает действовать
              с&nbsp;момента нарушения условия.
            </li>
          </ul>
        </div>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Карты каких банков я могу закрыть с помощью рефинансирования с Халвой?
      </p>,
      <div className={styles.listAnswer}>
        <p>Предложение действительно для кредитных карт любых российских банков.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Что будет, если просрочить ежемесячный платеж? </p>,
      <div className={styles.listAnswer}>
        <p>
          При просрочке от одного до пяти дней никаких санкций не предусмотрено. С шестого дня
          просрочки будут начислять 0,1 % от суммы просроченной задолженности за каждый день
          нарушения обязательств.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Когда и как списывается ежемесячный платеж?</p>,
      <div className={styles.listAnswer}>
        <p>
          Ежемесячный платеж списывают в течение платежного периода. Он составляет 15 дней и зависит
          от даты открытия Халвы. При наличии собственных средств на карте списание происходит
          автоматически.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Когда я погашу задолженность, карта «Халва» будет больше не нужна?
      </p>,
      <div className={styles.listAnswer}>
        <p>
          Карта «Халва» — универсальный банковский продукт, который сочетает в&nbsp;себе множество
          выгодных преимуществ. С&nbsp;помощью нее можно совершать покупки в&nbsp;рассрочку*,
          получать кэшбэк, осуществлять платежи и&nbsp;переводы, откладывать деньги на&nbsp;крупные
          покупки и&nbsp;многое другое!
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Можно будет снова воспользоваться кредитными средствами после погашения задолженности по
        рефинансированию?
      </p>,
      <div className={styles.listAnswer}>
        <br />

        <p>
          Заемный лимит по Халве возобновляемый. После погашения задолженности вы сможете
          воспользоваться им снова для рефинансирования других кредитных карт и оплаты товаров и
          услуг в рассрочку*.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Может ли студент оформить карту рассрочки*?</p>,
      <div className={styles.listAnswer}>
        <p>
          Студенты, достигшие 18 лет, вправе открыть карту рассрочки* «Халва» с возможностью
          использовать заемные средства. Для оформления карты потребуется паспорт гражданина РФ.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Какие документы нужно предоставить в банк для открытия карты?
      </p>,
      <div className={styles.listAnswer}>
        <p>В большинстве случаев Халву оформят по паспорту гражданина России.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Где можно оформить карту рассрочки* «Халва»?</p>,
      <div className={styles.listAnswer}>
        <p>
          Для этого предусмотрены два варианта: в ближайшем отделении банка или на сайте, отправив
          онлайн-заявку.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как разблокировать карту после блокировки владельцем?</p>,
      <div className={styles.listAnswer}>
        <p>
          Обратитесь в любое отделение банка, напишите оператору в чат мобильного приложения или
          позвоните по номеру 8 (800) 100-77-72.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Сколько времени банк хранит карту после ее выпуска?</p>,
      <div className={styles.listAnswer}>
        <p>
          Карту можно забрать в течение двух месяцев. Если после этого срока она останется
          невостребованной, ее уничтожат.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как узнать номер счета карты?</p>,
      <div className={styles.listAnswer}>
        <p>Номер счета можно найти в приложении:</p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>авторизуйтесь и выберите карту «Халва»;</li>
            <li>перейдите в раздел «Важно»;</li>
            <li>кликните по строчке «О карте».</li>
          </ul>
          <br />
          <p>
            Здесь собрана информация о номере счета, а также основные данные: номер карты и
            договора, срок действия, предоставленный лимит рассрочки*, наличие задолженности и т. д.
          </p>
        </div>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как узнать о готовности карты?</p>,
      <div className={styles.listAnswer}>
        <p>Вам поступит смс-сообщение или звонок от банковского сотрудника.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Меняются ли реквизиты карты при замене?</p>,
      <div className={styles.listAnswer}>
        <br />
        <div className={styles.htmlBlock}>
          <p>Это зависит от причины замены карты:</p>
          <ul>
            <li>плановой (истек срок действия) — реквизиты не меняют;</li>
            <li>
              внеплановой (в результате кражи или повреждения) — меняют номер, CVC/CVV-код и период
              действия. Банковские реквизиты остаются прежними
            </li>
          </ul>
        </div>
      </div>,
    ],
    [
      <p className={styles.listQuestion}> Где узнать условия по кэшбэку карты «Халва»?</p>,
      <div className={styles.listAnswer}>
        <p>
          Информация по получению кэшбэка собрана на официальном сайте Совкомбанка.
          <br />
          Данные по начисленному кэшбэку отражены в приложении «Халва — Совкомбанк».
        </p>
      </div>,
    ],
  ],
  media: [
    [
      <p className={styles.listQuestion}>Что такое карта рассрочки*?</p>,
      <div className={styles.listAnswer}>
        <p>
          Карта рассрочки* «Халва» — это пластиковое/виртуальное платежное средство. Какие операции
          с ней доступны:
        </p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>
              оплата товаров заемными средствами в беспроцентную рассрочку* в магазинах-партнерах;
            </li>
            <li>снятие наличных в рассрочку* на три месяца;</li>
            <li>использование в качестве дебетовой карты — хранение средств и оплата покупок;</li>
            <li>получение кэшбэка за оплаченные покупки;</li>
            <li>возможность откладывать деньги — открывать вклады и Онлайн-копилку.</li>
          </ul>
        </div>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как рефинансировать кредитные карты без процентов?</p>,
      <div className={styles.listAnswer}>
        <p>
          Рефинансирование — оформление нового кредита, с помощью которого закрывают действующий
          заем. Услуга помогает снизить финансовую нагрузку, объединить несколько задолженностей в
          одну, получить более выгодные условия.
        </p>
        <br />
        <p>
          С картой «Халва» можно рефинансировать долг по кредитке до 300 000 рублей в беспроцентную
          рассрочку*. Банк погасит заем и разделит сумму кредита на равные платежи, которые клиент
          будет вносить в течение нескольких месяцев. Срок зависит от нескольких условий:
        </p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>
              <strong>24 месяца</strong> — при оплате Халвой от десяти покупок в месяц на общую
              сумму не меньше 20 000 ₽ в течение всего срока;
            </li>
            <li>
              <strong>10 месяцев</strong> — если не удалось выполнить требование по минимальному
              обороту при наличии подписки «Халва.Десятка». Новый срок начинает действовать с
              момента нарушения условия;
            </li>
            <li>
              <strong>6 месяцев</strong> — если не удалось выполнить требование по минимальному
              обороту без подписки. Новый срок начинает действовать с момента нарушения условия.
            </li>
          </ul>
        </div>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Карты каких банков я могу закрыть с помощью рефинансирования с Халвой?
      </p>,
      <div className={styles.listAnswer}>
        <p>Предложение действительно для кредитных карт любых российских банков.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Что будет, если просрочить ежемесячный платеж? </p>,
      <div className={styles.listAnswer}>
        <p>
          При просрочке от одного до пяти дней никаких санкций не предусмотрено. С шестого дня
          просрочки будут начислять 0,1 % от суммы просроченной задолженности за каждый день
          нарушения обязательств.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Когда и как списывается ежемесячный платеж?</p>,
      <div className={styles.listAnswer}>
        <p>
          Ежемесячный платеж списывают в течение платежного периода. Он составляет 15 дней и зависит
          от даты открытия Халвы. При наличии собственных средств на карте списание происходит
          автоматически.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Нужна ли будет карта «Халва» после погашения задолженности?
      </p>,
      <div className={styles.listAnswer}>
        <p>
          Карта «Халва» — универсальный банковский продукт, который сочетает в себе множество
          выгодных преимуществ. С помощью нее можно совершать покупки в рассрочку*, получать кэшбэк
          и процент на остаток, осуществлять платежи и переводы, откладывать деньги на крупные
          покупки и многое другое!
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Можно будет снова воспользоваться кредитными средствами после погашения задолженности по
        рефинансированию?
      </p>,
      <div className={styles.listAnswer}>
        <br />

        <p>
          Заемный лимит по Халве возобновляемый. После погашения задолженности вы сможете
          воспользоваться им снова для рефинансирования других кредитных карт и оплаты товаров и
          услуг в рассрочку*.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Может ли студент оформить карту рассрочки*?</p>,
      <div className={styles.listAnswer}>
        <p>
          Студенты, достигшие 20 лет, вправе открыть карту рассрочки* «Халва» с возможностью
          использовать заемные средства. Для оформления карты потребуется паспорт гражданина РФ.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Какие документы нужно предоставить в банк для открытия карты?
      </p>,
      <div className={styles.listAnswer}>
        <p>В большинстве случаев Халву оформляют по паспорту гражданина России.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Где можно оформить карту рассрочки* «Халва»?</p>,
      <div className={styles.listAnswer}>
        <p>
          Для этого предусмотрены два варианта: в ближайшем отделении банка или на сайте, отправив
          онлайн-заявку.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как разблокировать карту после блокировки владельцем?</p>,
      <div className={styles.listAnswer}>
        <p>
          Обратитесь в любое отделение банка, напишите оператору в чат мобильного приложения или
          позвоните по номеру 8 (800) 100-77-72.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Сколько времени банк хранит карту после ее выпуска?</p>,
      <div className={styles.listAnswer}>
        <p>
          Карту можно забрать в течение двух месяцев. Если после этого срока она останется
          невостребованной, ее уничтожат.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как узнать номер счета карты?</p>,
      <div className={styles.listAnswer}>
        <p>Номер счета можно найти в приложении:</p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>авторизуйтесь и выберите карту «Халва»;</li>
            <li>перейдите в раздел «Важно»;</li>
            <li>кликните по строчке «О карте».</li>
          </ul>
          <br />
          <p>
            Здесь собрана информация о номере счета, а также основные данные: номер карты и
            договора, срок действия, предоставленный лимит рассрочки*, наличие задолженности и т. д.
          </p>
        </div>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как узнать о готовности карты?</p>,
      <div className={styles.listAnswer}>
        <p>Вам поступит смс-сообщение или звонок от банковского сотрудника.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Меняются ли реквизиты карты при замене?</p>,
      <div className={styles.listAnswer}>
        <br />
        <div className={styles.htmlBlock}>
          <p>Это зависит от причины замены карты:</p>
          <ul>
            <li>плановой (истек срок действия) — реквизиты не меняют;</li>
            <li>
              внеплановой (в результате кражи или повреждения) — меняют номер, CVC/CVV-код и период
              действия. Банковские реквизиты остаются прежними
            </li>
          </ul>
        </div>
      </div>,
    ],
    [
      <p className={styles.listQuestion}> Где узнать условия по кэшбэку карты «Халва»?</p>,
      <div className={styles.listAnswer}>
        <p>
          Информация по получению кэшбэка собрана на официальном сайте Совкомбанка.
          <br />
          Данные по начисленному кэшбэку отражены в приложении «Халва — Совкомбанк».
        </p>
      </div>,
    ],
  ],
  productCategories: [
    [
      <p className={styles.listQuestion}>Что такое карта рассрочки*?</p>,
      <div className={styles.listAnswer}>
        <p>
          Карта рассрочки* «Халва» — это пластиковое/виртуальное платежное средство. Какие операции
          с ней доступны:
        </p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>
              оплата товаров заемными средствами в беспроцентную рассрочку* в магазинах-партнерах;
            </li>
            <li>снятие наличных в рассрочку* на три месяца;</li>
            <li>использование в качестве дебетовой карты — хранение средств и оплата покупок;</li>
            <li>получение кэшбэка за оплаченные покупки;</li>
            <li>возможность откладывать деньги — открывать вклады и Онлайн-копилку.</li>
          </ul>
        </div>
      </div>,
    ],

    [
      <p className={styles.listQuestion}>Может ли студент оформить карту рассрочки*?</p>,
      <div className={styles.listAnswer}>
        <p>
          Студенты, достигшие 18 лет, вправе открыть карту рассрочки* «Халва» с возможностью
          использовать заемные средства. Для оформления карты потребуется паспорт гражданина РФ.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Какие документы нужно предоставить в банк для открытия карты?
      </p>,
      <div className={styles.listAnswer}>
        <p>В большинстве случаев Халву оформят по паспорту гражданина России.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Где можно оформить карту рассрочки* «Халва»?</p>,
      <div className={styles.listAnswer}>
        <p>
          Для этого предусмотрены два варианта: в ближайшем отделении банка или на сайте, отправив
          онлайн-заявку.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как разблокировать карту после блокировки владельцем?</p>,
      <div className={styles.listAnswer}>
        <p>
          Обратитесь в любое отделение банка, напишите оператору в чат мобильного приложения или
          позвоните по номеру 8 (800) 100-77-72.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Сколько времени банк хранит карту после ее выпуска?</p>,
      <div className={styles.listAnswer}>
        <p>
          Карту можно забрать в течение двух месяцев. Если после этого срока она останется
          невостребованной, ее уничтожат.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как узнать номер счета карты?</p>,
      <div className={styles.listAnswer}>
        <p>Номер счета можно найти в приложении:</p>
        <br />
        <div className={styles.htmlBlock}>
          <ul>
            <li>Авторизуйтесь и выберите «Карта Халва».</li>
            <li>Перейдите в раздел «Важно»;</li>
            <li>Кликните по строчке «О карте».</li>
          </ul>
          <br />
          <p>
            Здесь собрана информация о номере счета, а также основные данные: номер карты и
            договора, срок действия, предоставленный лимит рассрочки*, наличие задолженности и т. д.
          </p>
        </div>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как узнать о готовности карты?</p>,
      <div className={styles.listAnswer}>
        <p>Вам поступит СМС-сообщение или звонок от банковского сотрудника.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Меняются ли реквизиты карты при замене?</p>,
      <div className={styles.listAnswer}>
        <br />
        <div className={styles.htmlBlock}>
          <p>Это зависит от причины замены карты:</p>
          <ul>
            <li>плановой (истек срок действия) — реквизиты не меняют;</li>
            <li>
              внеплановой (в результате кражи или повреждения) — меняют номер, CVC/CVV-код и период
              действия. Банковские реквизиты остаются прежними
            </li>
          </ul>
        </div>
      </div>,
    ],
    [
      <p className={styles.listQuestion}> Где узнать условия по кэшбэку карты «Халва»?</p>,
      <div className={styles.listAnswer}>
        <p>
          Информация по получению кэшбэка собрана на официальном сайте Совкомбанка.
          <br />
          Данные по начисленному кэшбэку отражены в приложении «Халва — Совкомбанк».
        </p>
      </div>,
    ],
  ],
  instructionTraining: [
    [
      <p className={styles.listQuestion}>
        В чью пользу расходы <br className="d-md-none" />
        можно учесть?
      </p>,
      <div className={styles.answer}>
        <p>
          В пределах 150 тыс. руб.
          <br />
          (совокупно с другими социальными вычетами):
        </p>
        <ul>
          <li>Собственное обучение</li>
          <li>Брата/сестры до 24 лет при очном обучении</li>
          <li>Супруга/супруги (с 2024 года) при&nbsp;очном обучении</li>
        </ul>
        <br />
        <p>В пределах 110 тыс. руб.:</p>
        <ul>
          <li>
            Обучение каждого ребенка / подопечного до 18 лет <br className="d-none d-large-block" />
            (до 24 лет при&nbsp;очном обучении) совокупно на&nbsp;обоих родителей
          </li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какие есть особенности?</p>,
      <div className={styles.answer}>
        <ul>
          <li>
            У организации (ИП) должна быть лицензия на&nbsp;образовательную деятельность.{" "}
            <br className="d-none d-large-block" />
            Она не&nbsp;нужна, когда услуги оказывает непосредственно ИП, и&nbsp;в&nbsp;ЕГРИП
            указано, что он осуществляет образовательную деятельность
          </li>
          <li>
            Вы можете получить вычет при&nbsp;оплате, в&nbsp;частности, дошкольного образования,
            платных школ, музыкальных школ, вузов, автошкол, а&nbsp;также при&nbsp;дистанционном
            обучении
          </li>
          <li>
            Если вы единовременно оплатили многолетнее обучение, то&nbsp;сможете получить вычет
            только один раз – за&nbsp;год оплаты в&nbsp;пределах лимита
          </li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какие нужны документы?</p>,
      <div className={styles.answer}>
        <p className={styles.fw_bold}>По расходам до 2024 года:</p>
        <ul>
          <li>Договор с образовательным учреждением (ИП)</li>
          <li>Платежные документы, подтверждающие оплату обучения</li>
          <li>
            Копия лицензии или иного документа, подтверждающего право на&nbsp;ведение
            образовательного процесса
          </li>
          <li>
            Справка, подтверждающая очную форму обучения, если об&nbsp;этом не&nbsp;сказано
            в&nbsp;договоре – при&nbsp;оплате обучения брата/сестры или&nbsp;супруга/супруги
          </li>
          <li>
            Документы, подтверждающие родство – при&nbsp;оплате обучения брата/сестры
            или&nbsp;супруга/супруги
          </li>
        </ul>
        <br />
        <p className={styles.fw_bold}>По расходам с 2024 года:</p>
        <ul>
          <li>Справка об оплате образовательных услуг, выданная образовательной организацией</li>
          <li>
            Если обучение проходило в иностранной организации – вам потребуется документ,
            подтверждающий статус организации, <br className="d-none d-large-block" />
            осуществляющей образовательную деятельность, платежные документы, подтверждающие оплату
            услуг, а&nbsp;также нотариально заверенный перевод документов
          </li>
        </ul>
      </div>,
    ],
  ],
  instructionTreatment: [
    [
      <p className={styles.listQuestion}>
        В чью пользу расходы <br className="d-md-none" />
        можно учесть?
      </p>,
      <div className={styles.answer}>
        <ul>
          <li>Собственное лечение</li>
          <li>Супруга/супруги</li>
          <li>Родителей</li>
          <li>Детей/подопечных до 18 лет (до&nbsp;24&nbsp;лет при&nbsp;очном обучении)</li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какие расходы можно учесть?</p>,
      <div className={styles.answer}>
        <ul>
          <li>
            Лечение в организациях, имеющих лицензию на&nbsp;осуществление медицинской деятельности
          </li>
          <li>Приобретение выписанных врачом медикаментов</li>
          <li>Страховые взносы по&nbsp;договору ДМС</li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какие есть особенности?</p>,
      <div className={styles.answer}>
        <ul>
          <li>
            У медицинской организации (ИП) или&nbsp;страховой организации (в&nbsp;случае взносов
            по&nbsp;ДМС) должна быть лицензия на&nbsp;осуществление соответствующей деятельности
          </li>
          <li>
            При оплате дорогостоящего лечения учесть расходы можно в&nbsp;полном размере,
            а&nbsp;не&nbsp;в&nbsp;пределах общего лимита (150&nbsp;тыс. руб.). Если лечение
            дорогостоящее, то&nbsp;в&nbsp;справке об&nbsp;оплате медицинских услуг будет указан код
            «02». Для&nbsp;получения этой справки нужно обратиться в&nbsp;медицинское учреждение
          </li>
          <li>За покупку медицинских изделий вычет не&nbsp;полагается</li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какие нужны документы?</p>,
      <div className={styles.answer}>
        <p className={styles.fw_bold}>Для вычета на лечение:</p>
        <ul>
          <li>
            Справка об оплате медицинских услуг (обязательный документ, который нужно запросить у
            медицинского учреждения)
          </li>
          <li>Документы, подтверждающие родство, опеку или&nbsp;попечительство</li>
        </ul>
        <br />
        <p className={styles.fw_bold}>Для учета расходов на медикаменты:</p>
        <ul>
          <li>
            Рецептурный бланк, оформленный медицинским работником (если&nbsp;не&nbsp;оформляется,
            то&nbsp;возможно использование <br className="d-none d-tab-only-block" />
            сведений из&nbsp;медицинской документации пациента)
          </li>
          <li>
            Платёжные документы, подтверждающие расходы на&nbsp;покупку медикаментов (чеки
            и&nbsp;др.)
          </li>
          <li>Документы, подтверждающие родство, опеку или&nbsp;попечительство</li>
        </ul>
        <br />
        <p className={styles.fw_bold}>Для учета расходов на медикаменты:</p>
        <p>По расходам до 2024 года:</p>
        <ul>
          <li>Договор ДМС или страховой медицинский полис добровольного страхования</li>
          <li>Платёжные документы, подтверждающие расходы на&nbsp;уплату страховых взносов</li>
          <li>Документы, подтверждающие родство, опеку или&nbsp;попечительство</li>
        </ul>
        <br />
        <p>По расходам с 2024 года:</p>
        <ul>
          <li>
            Справка об уплате страховых взносов для представления в&nbsp;налоговый орган, выданная
            страховой организацией.
          </li>
          <li>Документы, подтверждающие родство, опеку или&nbsp;попечительство</li>
        </ul>
      </div>,
    ],
  ],
  instructionSport: [
    [
      <p className={styles.listQuestion}>
        В чью пользу расходы <br className="d-md-none" />
        можно учесть?
      </p>,
      <div className={styles.answer}>
        <ul>
          <li>Оплата собственных услуг</li>
          <li>
            Оплата услуг за детей/подопечных до&nbsp;18 лет (до 24 лет при&nbsp;очном обучении)
          </li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какие есть особенности?</p>,
      <div className={styles.answer}>
        <ul>
          <li>
            Вычет предоставляется, если организация (ИП) включена в утвержденный{" "}
            <AppLink
              target="_blank"
              rel="noreferrer"
              href="https://minsport.gov.ru/activities/o-nalogovom-vychete-za-zanyatiya-sportom/"
            >
              список
            </AppLink>{" "}
            Минспорта РФ на&nbsp;дату оплаты услуг
          </li>
          <li>Затраты на спортивный инвентарь компенсировать не&nbsp;получится</li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какие нужны документы?</p>,
      <div className={styles.answer}>
        <p className={styles.fw_bold}>По расходам до 2024 года:</p>
        <ul>
          <li>Договор на оказание физкультурно-оздоровительных услуг</li>
          <li>Кассовый чек</li>
          <li>Документы, подтверждающие родство, опеку или&nbsp;попечительство</li>
        </ul>
        <br />
        <p className={styles.fw_bold}>По расходам с 2024 года:</p>
        <ul>
          <li>
            Справка об оплате физкультурно-оздоровительных услуг для&nbsp;представления
            в&nbsp;налоговый орган, выданная физкультурно-спортивной организацией (ИП)
          </li>
          <li>Документы, подтверждающие родство, опеку или&nbsp;попечительство</li>
        </ul>
      </div>,
    ],
  ],
  instructionSocial: [
    [
      <p className={styles.listQuestion}>Что такое социальные налоговые вычеты?</p>,
      <div className={styles.answer}>
        В 2025 году по декларации 3-НДФЛ вы&nbsp;можете заявить вычеты по&nbsp;расходам
        за&nbsp;2024, 2023 и&nbsp;2022 годы. С&nbsp;2024&nbsp;года совокупный лимит социальных
        вычетов – 150&nbsp;тыс.&nbsp;руб. (ранее –&nbsp;120&nbsp;тыс.&nbsp;руб.)
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какие расходы входят в&nbsp;лимит социального вычета?</p>,
      <div className={styles.answer}>
        <ul>
          <li>Обучение (для обучения детей предусмотрен отдельный лимит)</li>
          <li>Лечение, покупку медикаментов, расходы по&nbsp;договору ДМС</li>
          <li>Физкультурно-оздоровительные услуги</li>
          <li>
            Пенсионные взносы по договору негосударственного пенсионного обеспечения с&nbsp;НПФ
            (до&nbsp;2024 года включительно)
          </li>
          <li>Страховые взносы по&nbsp;договору добровольного пенсионного страхования</li>
          <li>Страховые взносы по&nbsp;договору добровольного страхования жизни</li>
          <li>Дополнительные страховые взносы на&nbsp;накопительную пенсию</li>
          <li>Прохождение независимой оценки квалификации</li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Когда общий лимит не&nbsp;применяется?</p>,
      <div className={styles.answer}>
        <ol style={{ listStyle: "decimal", paddingLeft: "28px" }}>
          <li>
            Дорогостоящее лечение – лимит не&nbsp;установлен. Вы сможете учесть расходы
            в&nbsp;полном размере. В&nbsp;справке об&nbsp;оплате медицинских услуг должен быть
            указан код «02»
          </li>
          <li>
            Обучение детей – с&nbsp;2024 года лимит на&nbsp;обучение каждого ребенка в&nbsp;общей
            сумме на&nbsp;обоих родителей 110&nbsp;тыс.&nbsp;руб. (ранее – 50&nbsp;тыс.&nbsp;руб.)
          </li>
          <li>
            Благотворительность – к&nbsp;вычету можно заявить всю сумму расходов,
            но&nbsp;в&nbsp;размере не&nbsp;более 25% облагаемого дохода за&nbsp;год
          </li>
        </ol>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>На что нужно обратить внимание?</p>,
      <div className={styles.answer}>
        <ul>
          <li>
            Учесть можно только те&nbsp;расходы, которые вы понесли за&nbsp;счет собственных средств
          </li>
          <li>
            Неиспользованный остаток социального вычета не&nbsp;переносится на&nbsp;будущие годы
          </li>
        </ul>
      </div>,
    ],
  ],
  instructionProperty: [
    [
      <p className={styles.listQuestion}>Как вернуть налог, если я купил недвижимость?</p>,
      <div className={styles.answer}>
        Если вы приобрели в собственность жильё, дачу, садовый участок, земельный участок, вы можете
        воспользоваться имущественным вычетом. Право на&nbsp;вычет возникает с&nbsp;момента
        государственной регистрации права собственности на&nbsp;недвижимость.
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какой лимит установлен для&nbsp;имущественных вычетов?</p>,
      <div className={styles.answer}>
        <ul>
          <li>2 млн руб. - на&nbsp;приобретение жилья</li>
          <li>3 млн руб. - на&nbsp;уплату процентов по&nbsp;ипотеке</li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какие расходы можно учесть?</p>,
      <div className={styles.answer}>
        В состав расходов на&nbsp;покупку, помимо оплаты стоимости жилья, можно включить расходы
        на&nbsp;отделочные работы и&nbsp;материалы, если&nbsp;в&nbsp;договоре указано,
        что&nbsp;квартира/дом продается без&nbsp;отделки.
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Можно ли заявлять имущественные вычеты ежегодно?</p>,
      <div className={styles.answer}>
        <p>
          Воспользоваться вычетом на&nbsp;покупку недвижимости можно один раз в&nbsp;жизни. Если
          имущественный вычет был заявлен в&nbsp;прошлые годы в&nbsp;полном размере
          (2&nbsp;млн&nbsp;руб. или&nbsp;3&nbsp;млн&nbsp;руб.) - его повторное использование
          невозможно.
        </p>
        <br />
        <p>
          В случае если за&nbsp;один год вы не&nbsp;израсходовали установленный лимит полностью,
          то&nbsp;неиспользованный остаток вычета переносится на&nbsp;будущие периоды.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Когда я не вправе заявить имущественный вычет?</p>,
      <div className={styles.answer}>
        <ul>
          <li>Вычет нельзя получить, если вы купили недвижимость за&nbsp;рубежом.</li>
          <li>
            Вычет нельзя получить в&nbsp;части расходов, покрываемых за&nbsp;счет средств
            работодателей, средств материнского капитала, а&nbsp;также за&nbsp;счет выплат
            из&nbsp;бюджета РФ.
          </li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какие нужны документы?</p>,
      <div className={styles.answer}>
        <p className={styles.fw_bold}>Для вычета на приобретение жилья</p>
        <ul>
          <li>Выписка из ЕГРН</li>
          <li>
            Договор приобретения / строительства жилья / договор участия в долевом строительстве и
            передаточный акт
          </li>
          <li>Документы, подтверждающие расходы на покупку / строительство</li>
          <li>
            При приобретении жилья в общую совместную собственность – заявление о распределении
            вычета между супругами, если они распределили вычет между собой
          </li>
        </ul>
        <br />
        <p className={styles.fw_bold}>Для вычета на уплату процентов по ипотеке</p>
        <ul>
          <li>Документы для вычета на приобретение (указаны выше) </li>
          <li>Кредитный договор</li>
          <li>График погашения процентов по кредиту и справка об уплате процентов</li>
        </ul>
      </div>,
    ],
  ],
  instructionInvestors: [
    [
      <p className={styles.listQuestion}>
        Какие вычеты можно получить по&nbsp;ИИС, открытому до&nbsp;2023&nbsp;г.?
      </p>,
      <div className={styles.answer}>
        <p>
          Если у Вас ИИС «старого типа» (т.е.&nbsp;открытый до&nbsp;конца 2023 года), вы можете
          заявить один вычет по&nbsp;выбору:
        </p>
        <br />
        <ul>
          <li>
            Вычет «на взнос» (типа А) – в&nbsp;сумме внесенных за&nbsp;год средств на&nbsp;ИИС
            в&nbsp;пределах 400&nbsp;тыс.&nbsp;руб. (заявляется самостоятельно), или
          </li>
          <li>
            Вычет «на прибыль» (типа Б) – безлимитно в&nbsp;сумме прибыли по&nbsp;операциям
            на&nbsp;ИИС (применяет брокер при&nbsp;закрытии ИИС).
          </li>
        </ul>
        <br />
        <p>
          Вычет можно получить, если у&nbsp;вас есть только один действующий договор на&nbsp;ведение
          ИИС, заключенный на&nbsp;срок не&nbsp;менее 3 лет.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Как вернуть налог, имея долгосрочные сбережения или&nbsp;ИИС-3?
      </p>,
      <div className={styles.answer}>
        <p>Вычеты на долгосрочные сбережения предоставляется по&nbsp;следующим расходам:</p>
        <br />
        <ol style={{ listStyle: "decimal", paddingLeft: "28px" }}>
          <li>
            Пенсионные взносы по&nbsp;договорам НПО, предусматривающим выплату негосударственной
            пенсии, заключенным в&nbsp;свою пользу, в&nbsp;пользу членов семьи и&nbsp;близких
            родственников (в&nbsp;отношении взносов, уплаченных с&nbsp;2025 года);
          </li>
          <li>
            Сберегательные взносы по&nbsp;договорам долгосрочных сбережений (ДС), заключенным
            в&nbsp;свою пользу или&nbsp;в&nbsp;пользу членов семьи и&nbsp;близких родственников,
            если основания для&nbsp;назначения выплат по&nbsp;таким договорам наступают
            не&nbsp;ранее чем через 10 лет с&nbsp;даты заключения (в&nbsp;отношении доходов/взносов
            с&nbsp;2024 года);
          </li>
          <li>
            Вычеты по&nbsp;ИИС-3, открытому с&nbsp;2024 года (можно получить оба типа вычета):
            <br />
            <ul>
              <li>Вычет «на взнос» - в&nbsp;сумме денежных средств, внесенных на&nbsp;ИИС-3;</li>
              <li>
                Вычет «на прибыль» - предоставляется по&nbsp;окончании договора на&nbsp;ведение
                ИИС-3, но&nbsp;не&nbsp;раньше истечения минимального срока ведения (от&nbsp;5
                до&nbsp;10 лет в&nbsp;зависимости от&nbsp;даты открытия счета).
              </li>
            </ul>
          </li>
        </ol>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Какой лимит установлен для&nbsp;вычетов на&nbsp;долгосрочные сбережения (ДС)?
      </p>,
      <div className={styles.answer}>
        <ol style={{ listStyle: "decimal", paddingLeft: "28px" }}>
          <li>
            400 тыс. руб. - общий лимит для&nbsp;ваших расходов на&nbsp;пенсионные взносы,
            сберегательные взносы и&nbsp;взносы на&nbsp;ИИС-3.
          </li>
          <li>
            30 млн руб. - лимит вычета «на&nbsp;прибыль» по&nbsp;ИИС-3, который установлен
            для&nbsp;всех договоров ИИС-3, прекращенных в&nbsp;одном году.
          </li>
        </ol>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Какие есть ограничения по&nbsp;вычетам на&nbsp;долгосрочные сбережения?
      </p>,
      <div className={styles.answer}>
        <ul>
          <li>
            Чтобы сохранить право на&nbsp;вычет по&nbsp;договору ДС, можно иметь не&nbsp;более 3
            договоров ДС (кроме случаев прекращения договора ДС с&nbsp;переводом сумм в&nbsp;другой
            НПФ).
          </li>
          <li>
            Чтобы сохранить право на&nbsp;вычеты по&nbsp;ИИС-3, можно иметь не&nbsp;более 3
            договоров на&nbsp;ведение ИИС-3 (кроме случаев прекращения договора на&nbsp;ведение ИИС
            с&nbsp;переводом всех активов на&nbsp;другой ИИС-3).
          </li>
        </ul>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какие нужны документы?</p>,
      <div className={styles.answer}>
        <p className={styles.fw_bold}>Для вычета «на взнос» по ИИС «старого типа» или ИИС-3</p>
        <ul>
          <li>Договор на ведение ИИС</li>
          <li>Документы, подтверждающие зачисление денежных средств на ИИС</li>
        </ul>
        <br />
        <p className={styles.fw_bold}>Для вычета на пенсионные взносы по договору НПО</p>
        <ul>
          <li>Документ об уплате взносов по договору НПО, выданный НПФ</li>
        </ul>
        <br />
        <p className={styles.fw_bold}>Для вычета на сберегательные взносы по договору ДС</p>
        <ul>
          <li>Документ об уплате взносов по договору ДС, выданный НПФ</li>
        </ul>
      </div>,
    ],
  ],
  default: [
    [
      <p className={styles.listQuestion}>Какая кредитная ставка по Халве?</p>,
      <div className={styles.listAnswer}>
        <p>
          Можете забыть об этом термине, это не кредитная карта. С нашей картой вам доступна
          рассрочка*. За нее платить не нужно, эти расходы ложатся на магазины-партнеры банка.
        </p>
        <br />
        <p>
          На практике это выглядит так: вы расплачиваетесь у одного из партнеров заемными деньгами.
          Никаких дополнительных договоров заключать не нужно.
        </p>
        <br />
        <p>
          Сумма автоматически разбивается на равные платежи с графиком погашения на срок до десяти
          месяцев.
        </p>
        <br />
        <p>
          Раз в 30 дней пополняйте баланс, чтобы без переплат в комфортном темпе погасить
          задолженность.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>«Халва» – это кредитная карта?</p>,
      <div className={styles.listAnswer}>
        <p>
          Эта карточка универсальна. Она не кредитная карта, а рассрочки*. Оплачивайте у партнеров
          заказы в онлайн- и офлайн-магазинах деньгами банка. Снимайте деньги в долг на срок до трех
          месяцев.
        </p>
        <br />
        <p>
          Лимит рассрочки* нужен для подстраховки, и в повседневной жизни вы пользуетесь им редко?
          Храните на Халве собственные рубли (пользуйтесь как обычной дебетовой картой) и получайте
          процент на оставшиеся деньги. А если оплачиваете своими деньгами товары и услуги в
          магазинах-партнерах, часть потраченных средств вернется баллами кэшбэка.
        </p>
        <br />
        <p>
          Переключайтесь между кредитным и дебетовым счетами одним нажатием в личном кабинете на
          сайте банка или в приложении «Халва — Совкомбанк». Интернет-банк удобен тем, что все
          сервисы доступны онлайн.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>В чем отличие карты рассрочки* от кредитной карты?</p>,
      <div className={styles.listAnswer}>
        <p>
          Кредитная карта — пластиковый кошелек с кредитным лимитом. Тратить деньги можно на любые
          цели. Чтобы погасить долг без переплат, у заемщика есть льготный период (грейс-период).
          Обычно это срок в три-четыре месяца.
        </p>
        <br />
        <p>
          Если вы не успеваете вернуть долг до окончания беспроцентного периода, на сумму кредита
          начисляются проценты по ставке 30–60% годовых (в зависимости от банка). Долг сразу
          становится значительно больше.
        </p>
        <br />
        <p>
          Рассрочка* работает по-другому: вы оплачиваете покупку, а магазин-партнер компенсирует
          банку сумму за использование заемных средств. Стоимость покупки нужно вернуть в срок до
          десяти месяцев, что гораздо комфортнее рамок кредитного лимита. Никаких переплат.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>В чем суть карты рассрочки*?</p>,
      <div className={styles.listAnswer}>
        <p>
          Она дает возможность оплачивать услуги и покупать товары у партнеров банка заемными
          средствами без переплат. Пополняйте вовремя баланс на сумму ежемесячного платежа, тогда
          такой заем не потребует оплаты.
        </p>
        <br />
        <p>
          В отличие от бесплатного периода по кредитной карте, рассрочка* оформляется на более
          долгий срок (до десяти месяцев у Халвы).
        </p>
        <br />
        <p>
          Покупаете телевизор за 50 000 рублей в рассрочку* на пять месяцев. Ежемесячно возвращаете
          на карту 10 000 рублей, и по истечении срока задолженность закрывается. Ничего сверх 50
          000 рублей доплачивать не нужно. В таком формате вы пользуетесь деньгами банка бесплатно.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Влияет ли наличие карты на кредитную нагрузку?</p>,
      <div className={styles.listAnswer}>
        <p>
          Когда вы покупаете что-то в рассрочку*, появляется задолженность. Ее, как и в случае со
          всеми подобными финансовыми услугами, учитывают при расчете кредитной нагрузки и вносят в
          кредитную историю.
        </p>
        <br />
        <p>
          Воспользуйтесь этим для создания репутации надежного заемщика с хорошей кредитной
          историей. Покупайте иногда товары в рассрочку* и вовремя пополняйте баланс, погашая долг.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Кредитный лимит и лимит рассрочки* – одно и то же?</p>,
      <div className={styles.listAnswer}>
        <p>
          Деньги банка — заемные. Они доступны и по кредиту, и по рассрочке*. Их можно тратить на
          свои нужды. Но есть разница.
        </p>
        <br />
        <p>
          Деньги с кредитной карты часто используют для оплаты небольших покупок, потому что
          проценты по такому займу будут начисляться, как только кончится короткий льготный период.
          Не рассчитаете финансовую нагрузку, и долг сразу станет значительно больше.
        </p>
        <br />
        <p>Зато потратить кредитные средства заемщик может на что угодно.</p>
        <br />
        <p>
          Деньги рассрочки* можно тратить на покупки в любых магазинах, но выгоднее это делать у
          партнеров банка. У Халвы их более 260 000.
        </p>
        <br />
        <p>
          Возвращать заемные средства проще. Сумму можно разбить на ежемесячные платежи (на срок до
          десяти месяцев). Поэтому с Халвой удобно без переплат покупать, например дорогостоящую
          технику.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Какой минимальный и максимальный кредитный лимит?</p>,
      <div className={styles.listAnswer}>
        <p>
          На балансе Халвы может быть от 15 000 рублей заемных средств. Но количество доступных
          средств бывает и значительно больше. Максимум — 500 000 рублей.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Как увеличить лимит рассрочки* на карте «Халва»?</p>,
      <div className={styles.listAnswer}>
        <p>
          Доступный размер рассрочки* растет постепенно. Чтобы его увеличивать, нужно несколько раз
          в месяц (от десяти) оплачивать пластиком любые услуги и товары и потратить на это в сумме
          от 20 000 ₽.
        </p>
        <br />
        <p>
          Необязательно тратить заемные деньги. Пользуйтесь Халвой как дебетовой картой,
          распоряжаясь своими рублями. Этого достаточно, чтобы сумму рассрочки* можно было со
          временем увеличить.
        </p>
        <br />
        <p>
          Вы можете переключиться с режима траты заемных средств на свои. Для этого нужно лишь
          открыть приложение и внести нужное изменение.
        </p>
        <br />
        <p>
          Также вы можете совершать денежные переводы своим родным и друзьям на карты других банков
          или по СБП.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Что будет, если просрочить ежемесячный платеж?</p>,
      <div className={styles.listAnswer}>
        <p>
          При просрочке от одного до пяти дней никаких санкций не предусмотрено. С шестого дня
          просрочки будут начислять 0,1 % от суммы просроченной задолженности за каждый день
          нарушения обязательств.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Когда и как списывается ежемесячный платеж?</p>,
      <div className={styles.listAnswer}>
        <p>
          Погашать задолженность на Халве легко. Достаточно пополнять баланс на сумму ежемесячного
          платежа и в одно нажатие направлять деньги на уменьшение долга. Или еще проще: настроить
          автоматическое списание с карты. В таком случае останется только контролировать, чтобы
          денег на счете хватало для взноса.
        </p>
        <br />
        <p>За графиком можно следить на сайте банка или в приложении «Халва — Совкомбанк».</p>
        <br />
        <p>Платеж начисляется с учетом двух периодов: расчетного и платежного.</p>
        <br />
        <p>
          Первый начинается со дня, когда вы заключили договор, и обновляется раз в месяц (например,
          по договору от 18 апреля это будет период с 18 числа одного месяца до 18 числа
          следующего). В этот срок вы можете оформить несколько рассрочек*. Первый общий платеж по
          ним нужно будет внести в течение 15 дней после завершения расчетного периода.
        </p>
        <br />
        <p>Платежный период — 15 дней со дня завершения расчетного.</p>
      </div>,
    ],
  ],
}

const BENEFITS_LIST = {
  debet: [
    [
      <p className={styles.listQuestion}>Кэшбэк и бонусы за покупки</p>,
      <div className={styles.listAnswer}>
        <p>
          Карта «Халва» — не только источник заемных средств. Каждый владелец может использовать ее
          как дебетовую: хранить на ней личные средства, оплачивать покупки и совершать онлайн- и
          другие важные платежи, а также копить кэшбэк.
        </p>
        <br />
        <p>
          Гибкая и прозрачная система лояльности — несомненное преимущество Халвы. 1 балл кэшбэка =
          1 рубль. Максимальное количество баллов в месяц — 5000.
        </p>
        <br />
        <p>За покупки у партнеров до 9 999 рублей начисляют 2%.</p>
        <br />
        <p>
          Хотите увеличить кэшбэк? Подключите подписку «Халва.Десятка» и получайте до 10% возврата
          за покупки у партнеров. Это особенно выгодно для любителей онлайн-шопинга: за оплату
          своими средствами на сумму от 10 тысяч рублей на сайтах партнеров начислят 10% кэшбэка. То
          же правило действует на оплату сервисом Рау или платежным стикером в магазинах-партнерах.
        </p>
        <br />
        <p>Без подписки и с меньшим чеком также можно получать приятные бонусы. Давайте сравним.</p>
        <table className={styles.cashbackTable}>
          <thead>
            <tr>
              <th className={styles.headerCell}>Тип оплаты собственными средствами</th>
              <th className={styles.headerCell}>Размер кашбэка без&nbsp;подписки</th>
              <th className={styles.headerCell}>Размер кашбэка с&nbsp;подпиской «Халва Десятка»</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>У партнеров (до 9 999 рублей)</td>
              <td>2%</td>
              <td>4%</td>
            </tr>
            <tr>
              <td>
                Покупка у&nbsp;партнеров в&nbsp;интернете, оплата сервисом Pay или&nbsp;платежным
                стикером
              </td>
              <td>5%</td>
              <td>10%</td>
            </tr>
            <tr>
              <td>Поездка на&nbsp;такси «Яндекс GO»</td>
              <td>5%</td>
              <td>10%</td>
            </tr>
            <tr>
              <td>Покупки не&nbsp;у&nbsp;партнеров</td>
              <td>1%</td>
              <td>2%</td>
            </tr>
          </tbody>
        </table>
        <br />
        <p>
          С Халвой выгодно не только покупать, но и даже оплачивать коммунальные счета. За оплату
          ЖКХ через приложение «Халва – Совкомбанк» или в личном кабинете на сайте банка начислят 2%
          кешбэка (с подпиской) или 1% (без подписки).
        </p>
        <br />
        <p>
          Баллы кэшбэка начисляем ежемесячно по окончании текущего отчетного периода при выполнении
          правила «10×20» (от 10 покупок ежемесячно на общую сумму от 20 000 ₽) или 10×10 (от 10
          покупок ежемесячно на общую сумму от 10 000 ₽ по Социальной Халве). Их можно обменять на
          рубли, накопив минимум 300 баллов. Если набрали меньше, баллы не сгорят, а перенесутся на
          следующий месяц.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Оформление виртуальной карты</p>,
      <div className={styles.listAnswer}>
        <p>
          Она нужна для безопасной оплаты в интернете, а также для более удобного контроля финансов.
          На виртуальный банковский продукт можно установить ограничение по расходам, а в остальном
          он ничем не отличается от физического пластика. Виртуальную карточку будет видно только в
          приложении.
        </p>
        <br />
        <p>
          Не все банки предоставляют клиентам возможность оформить виртуальный инструмент в пару к
          дебетовому. А в Совкомбанке это просто, как дважды два. Вам не нужно даже обращаться в
          отделение или звонить в службу поддержки.
        </p>
        <br />
        <p>
          Создать виртуальную карту вы сможете в приложении. Это займет пару минут, и новая
          виртуальная карточка будет у вас под рукой.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Не нужно копить на покупки</p>,
      <div className={styles.listAnswer}>
        <p>
          Главное преимущество Халвы — она дает возможность купить то, что раньше было недоступно.
        </p>
        <br />
        <p>
          Планирование расходов — важное правило финансовой грамотности. Но порой траты сваливаются
          на нас неожиданно.
        </p>
        <br />
        <p>
          С картой рассрочки* не нужно копить или ждать подходящего момента — вы можете купить
          необходимую вещь сейчас, а расплачиваться за нее понемногу каждый месяц. Совершенно без
          переплат.
        </p>
        <br />
        <div className={styles.htmlBlock}>
          <p>Это напоминает кредит. Но есть отличия:</p>
          <br />
          <ul>
            <li>отсутствие процентов;</li>
            <li>лимит – до 500 тысяч рублей;</li>
            <li>
              больше 260 тысяч магазинов-партнеров с привлекательными предложениями для клиентов
              Халвы.
            </li>
          </ul>
        </div>
        <p>
          Именно партнеры платят проценты вместо вас. Среди них — крупные магазины, которые вы точно
          знаете.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Бесплатные выпуск и обслуживание</p>,
      <div className={styles.listAnswer}>
        <p>
          Кажется, сейчас сложно удивить кого-то бесплатным обслуживанием. Но даже крупные банки все
          еще списывают комиссию за работу «пластика».
        </p>
        <br />
        <p>
          Халва — это ноль расходов и максимум прибыли. Обслуживание бесплатно на протяжении всего
          срока пользования. А оформить ее можно в любом отделении или прямо из дома, удаленно с
          доставкой курьером.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Оформление и получение</p>,
      <div className={styles.listAnswer}>
        <p>Обе карты можно получить по паспорту. В чем же тогда отличие?</p>
        <br />
        <p>Дебетовую выдают только в отделении банка.</p>
        <br />
        <p>
          Предоставив паспорт, вы получите лимит заемных средств на Халве, который в дальнейшем
          можно увеличить. А если вы очень заняты, то курьер привезет вам ее на любой удобный адрес
          и к точному времени.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Наличные в рассрочку*</p>,
      <div className={styles.listAnswer}>
        <p>
          Ситуации бывают разные, и не всегда можно оплатить что-то «пластиком». Что делать, если
          нужны наличные средства? Идти за кредитом?
        </p>
        <br />
        <p>
          Конечно же, нет. Мы предусмотрели все, включая возможность снять заемные средства через
          банкомат. Получается, что вы можете взять наличные средства в рассрочку* на 3 месяца.
        </p>
        <br />
        <p>Это явное преимущество, ведь так вы ограничены только своим балансом.</p>
      </div>,
    ],
  ],
  refin: [
    [
      <p className={styles.listQuestion}>Управляйте одной картой</p>,
      <div className={styles.listAnswer}>
        <p>
          Удобно, когда все платежные инструменты сосредоточены в одной карте. Халвой можно
          пользоваться как обычной дебетовой картой и при этом гасить долг комфортными ежемесячными
          платежами. Она помогает равномерно распределить финансовую нагрузку.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Бесплатные выпуск и обслуживание</p>,
      <div className={styles.listAnswer}>
        <p>
          Карта «Халва» абсолютно бесплатна! Вам не придется платить ни за выпуск, ни за
          обслуживание.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Оформление и получение</p>,
      <div className={styles.listAnswer}>
        <p>
          Оформить карту можно не выходя из дома. Оставьте онлайн-заявку, дождитесь звонка
          сотрудника банка, подтвердите свои данные. Получить Халву можно в одном из отделений
          Совкомбанка или заказав бесплатную курьерскую доставку.
        </p>
      </div>,
    ],
  ],
  sticker: [
    [
      <p className={styles.listQuestion}>Бесплатное обслуживание</p>,
      <div className={styles.listAnswer}>
        <p>
          Для ребёнка — 599&nbsp;₽ выпуск, 0&nbsp;₽ обслуживание. Для взрослого — 599&nbsp;₽ выпуск,
          0&nbsp;₽ обслуживание при наличии Подписки или при ежемесячном совершении стикером
          от&nbsp;10&nbsp;покупок на&nbsp;общую сумму от&nbsp;20&nbsp;000&nbsp;₽ (иначе комиссия
          999&nbsp;₽ единоразово).
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Кэшбэк до&nbsp;10% </p>,
      <div className={styles.listAnswer}>
        <p>
          Для родителей кэшбэк — до 10% с&nbsp;подпиской «Халва.Десятка»,
          <br className="d-md-none" /> для детей&nbsp;—&nbsp;до&nbsp;5%.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Яркий и&nbsp;стильный дизайн</p>,
      <div className={styles.listAnswer}>
        <p>
          Множество ярких и&nbsp;необычных дизайнов, которые понравятся как взрослым, так
          и&nbsp;детям.
        </p>
      </div>,
    ],
  ],
  bezProcentov: [
    [
      <p className={styles.listQuestion}>Управляйте одной картой</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          Удобно, когда все платежные инструменты сосредоточены в одной карте. Халвой можно
          пользоваться как обычной дебетовой картой и при этом гасить долг комфортными ежемесячными
          платежами. Она помогает равномерно распределить финансовую нагрузку.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Повышенный кэшбэк</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          <AppLink
            target="_blank"
            href="https://peertube-ext.sovcombank.ru/videos/embed/2d899559-cc79-471f-a14b-300726b65cdf?title=0&warningTitle=0&controlBar=0&peertubeLink=0"
            rel="noreferrer"
          >
            Баллы кэшбэка
          </AppLink>{" "}
          начисляются за&nbsp;любые покупки собственными средствами. Они суммируются
          и&nbsp;становятся доступными для&nbsp;возмещения (обмена на&nbsp;рубли)
          после&nbsp;окончания каждого отчетного периода, если&nbsp;в&nbsp;нем накоплено
          от&nbsp;300&nbsp;баллов*
        </p>
        <br />
        <p>
          При подключении подписки{" "}
          <AppLink target="_blank" href="https://halvacard.ru/halvadesyatka" rel="noreferrer">
            «Халва.Десятка»
          </AppLink>{" "}
          кэшбэк УДВАИВАЕТСЯ!
        </p>
        <br />
        <p>
          <div className={styles.subtitle}>Размер кэшбэка c подпиской</div>
        </p>
        <br />
        <p>Покупка у партнеров Халвы:</p>
        <br />
        <ul>
          <li>— 4% - с подпиской (2% - без&nbsp;подписки);</li>
          <li>
            — 10% - за покупку от 10 000 р. сервисом Рау, стикером, в&nbsp;Интернете
            с&nbsp;подпиской (5% - без&nbsp;подписки);
          </li>
          <li>
            — 10% - за поездку на такси «Яндекс&nbsp;Go» с&nbsp;подпиской (5% - без&nbsp;подписки).
          </li>
        </ul>
        <br />
        <p>Покупка не у партнеров и&nbsp;оплата ЖКХ**:</p>
        <br />
        <ul>
          <li>— 2% - с подпиской (1% - без&nbsp;подписки).</li>
        </ul>
        <br />
        <p>
          * Если за отчетный период накоплено менее&nbsp;300&nbsp;баллов,
          то&nbsp;они&nbsp;переносятся на&nbsp;следующий отчетный период и&nbsp;суммируются
          с&nbsp;баллами, которые будут в&nbsp;нем накоплены. Продолжайте активно пользоваться
          картой, чтобы быстрее накопить необходимое для&nbsp;возмещения количество баллов.
        </p>
        <br />
        <p>
          ** Кэшбэк начисляется за оплату ЖКХ собственными и&nbsp;заемными средствами
          в&nbsp;приложении{" "}
          <AppLink target="_blank" href="https://pwa.scb.ru/" rel="noreferrer">
            «Халва&nbsp;-&nbsp;Совкомбанк»
          </AppLink>{" "}
          или&nbsp;
          <AppLink target="_blank" href="https://halvacard.ru/lk2/" rel="noreferrer">
            личном кабинете
          </AppLink>
          .
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Проценты на остаток собственных средств</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          С Халвой удобно управлять личными финансами: храните на ней деньги и получайте пассивный
          доход — проценты на минимальный остаток на счете собственных средств.
        </p>
        <br />
        <p>
          Чтобы открыть максимум преимуществ, оформите подписку «Халва.Десятка» (если вы получили
          первую карту после 5 декабря 2022 года). Тогда вам станет доступна опция 17% годовых на
          остаток на протяжении трех месяцев. Для этого купите пять или более товаров от 10 000
          рублей за месяц.
        </p>
        <br />
        <p>
          С четвертого месяца повышенная ставка составляет 10,5% при подключенной подписке
          «Халва.Десятка» и выполнении условий программы «Бонус 5х10» для обычной Халвы и «Бонус
          5х5» для социальной карты.
        </p>
        <br />
        <p>
          Повышенный процент начисляется на остаток до 400 000 рублей, для суммы свыше ставки не
          начисляется.
        </p>
        <br />
        <p>
          Для тех, кто оформил договор раньше, повышенный кэшбэк на остаток собственных средств с
          подпиской равен 10,5%.
        </p>
        <br />
        <p>
          <div className={styles.subtitle}>
            Покупаете по карте больше пяти раз (на сумму от 10 000 рублей), но еще не оформили
            подписку «Халва.Десятка»?
          </div>
        </p>
        <p>Получайте ежемесячно бонус на оставшиеся деньги по ставке 6% годовых.</p>
        <p>При невыполнении минимального оборота - 0%</p>
        <br />
        <p>Копите с выгодой, не теряя возможности распоряжаться своими деньгами без ограничений.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Бесплатные выпуск и обслуживание</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          Карта «Халва» абсолютно бесплатна! Вам не придется платить ни за выпуск, ни за
          обслуживание.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Оформление и получение</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          Оформить карту можно не выходя из дома. Оставьте онлайн-заявку, дождитесь звонка
          сотрудника банка, подтвердите свои данные. Получить Халву можно в одном из отделений
          Совкомбанка или заказав бесплатную курьерскую доставку.
        </p>
      </div>,
    ],
  ],
  bezProcentov24MesMedia: [
    [
      <p className={styles.listQuestion}>Управляйте одной картой</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          Удобно, когда все платежные инструменты сосредоточены в одной карте. Халвой можно
          пользоваться как обычной дебетовой картой и при этом гасить долг комфортными ежемесячными
          платежами. Она помогает равномерно распределить финансовую нагрузку.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Повышенный кэшбэк</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          <AppLink
            target="_blank"
            href="https://peertube-ext.sovcombank.ru/videos/embed/2d899559-cc79-471f-a14b-300726b65cdf?title=0&warningTitle=0&controlBar=0&peertubeLink=0"
            rel="noreferrer"
          >
            Баллы кэшбэка
          </AppLink>{" "}
          начисляются за&nbsp;любые покупки собственными средствами. Они суммируются
          и&nbsp;становятся доступными для&nbsp;возмещения (обмена на&nbsp;рубли)
          после&nbsp;окончания каждого отчетного периода, если&nbsp;в&nbsp;нем накоплено
          от&nbsp;300&nbsp;баллов*
        </p>
        <br />
        <p>
          При подключении подписки{" "}
          <AppLink target="_blank" href="https://halvacard.ru/halvadesyatka" rel="noreferrer">
            «Халва.Десятка»
          </AppLink>{" "}
          кэшбэк УДВАИВАЕТСЯ!
        </p>
        <br />
        <p>
          <div className={styles.subtitle}>Размер кэшбэка c подпиской</div>
        </p>
        <br />
        <p>Покупка у партнеров Халвы:</p>
        <br />
        <ul>
          <li>— 4% - с подпиской (2% - без&nbsp;подписки);</li>
          <li>
            — 10% - за покупку от 10 000 р. сервисом Рау, стикером, в&nbsp;Интернете
            с&nbsp;подпиской (5% - без&nbsp;подписки);
          </li>
          <li>
            — 10% - за поездку на такси «Яндекс&nbsp;Go» с&nbsp;подпиской (5% - без&nbsp;подписки).
          </li>
        </ul>
        <br />
        <p>Покупка не у партнеров и&nbsp;оплата ЖКХ**:</p>
        <br />
        <ul>
          <li>— 2% - с подпиской (1% - без&nbsp;подписки).</li>
        </ul>
        <br />
        <p>
          * Если за отчетный период накоплено менее&nbsp;300&nbsp;баллов,
          то&nbsp;они&nbsp;переносятся на&nbsp;следующий отчетный период и&nbsp;суммируются
          с&nbsp;баллами, которые будут в&nbsp;нем накоплены. Продолжайте активно пользоваться
          картой, чтобы быстрее накопить необходимое для&nbsp;возмещения количество баллов.
        </p>
        <br />
        <p>
          ** Кэшбэк начисляется за оплату ЖКХ собственными и&nbsp;заемными средствами
          в&nbsp;приложении{" "}
          <AppLink target="_blank" href="https://pwa.scb.ru/" rel="noreferrer">
            «Халва&nbsp;-&nbsp;Совкомбанк»
          </AppLink>{" "}
          или&nbsp;
          <AppLink target="_blank" href="https://halvacard.ru/lk2/" rel="noreferrer">
            личном кабинете
          </AppLink>
          .
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Проценты на остаток собственных средств</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          С Халвой удобно управлять личными финансами: храните на ней деньги и получайте пассивный
          доход — проценты на минимальный остаток на счете собственных средств.
        </p>
        <br />
        <p>
          Чтобы открыть максимум преимуществ, оформите подписку «Халва.Десятка». Вы получаете{" "}
          <span className={styles.fw_bold}>17%&nbsp;годовых</span> первые 3 мес. после выдачи карты
          (для впервые оформленных договоров),{" "}
          <span className={styles.fw_bold}>15%&nbsp;годовых</span> с 4-го месяца. Проценты
          начисляются на остаток до 400&nbsp;000 руб. Без подписки и на сумму свыше 400&nbsp;000
          руб. проценты не начисляются.
        </p>
        <br />
        <p>Копите с выгодой, не теряя возможности распоряжаться своими деньгами без ограничений.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Бесплатные выпуск и обслуживание</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          Карта «Халва» абсолютно бесплатна! Вам не придется платить ни за выпуск, ни за
          обслуживание.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Оформление и получение</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          Оформить карту можно не выходя из дома. Оставьте онлайн-заявку, дождитесь звонка
          сотрудника банка, подтвердите свои данные. Получить Халву можно в одном из отделений
          Совкомбанка или заказав бесплатную курьерскую доставку.
        </p>
      </div>,
    ],
  ],
  bezProcentov36Mes: [
    [
      <p className={styles.listQuestion}>Управляйте одной картой</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          Удобно, когда все платежные инструменты сосредоточены в одной карте. Халвой можно
          пользоваться как обычной дебетовой картой и при этом гасить долг комфортными ежемесячными
          платежами. Она помогает равномерно распределить финансовую нагрузку.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Повышенный кэшбэк</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          <AppLink
            target="_blank"
            href="https://peertube-ext.sovcombank.ru/videos/embed/2d899559-cc79-471f-a14b-300726b65cdf?title=0&warningTitle=0&controlBar=0&peertubeLink=0"
            rel="noreferrer"
          >
            Баллы кэшбэка
          </AppLink>{" "}
          начисляются за&nbsp;любые покупки собственными средствами. Они суммируются
          и&nbsp;становятся доступными для&nbsp;возмещения (обмена на&nbsp;рубли)
          после&nbsp;окончания каждого отчетного периода, если&nbsp;в&nbsp;нем накоплено
          от&nbsp;300&nbsp;баллов*
        </p>
        <br />
        <p>
          При подключении подписки{" "}
          <AppLink target="_blank" href="https://halvacard.ru/halvadesyatka" rel="noreferrer">
            «Халва.Десятка»
          </AppLink>{" "}
          кэшбэк УДВАИВАЕТСЯ!
        </p>
        <br />
        <p>
          <div className={styles.subtitle}>Размер кэшбэка c подпиской</div>
        </p>
        <br />
        <p>Покупка у партнеров Халвы:</p>
        <br />
        <ul>
          <li>— 4% - с подпиской (2% - без&nbsp;подписки);</li>
          <li>
            — 10% - за покупку от 10 000 р. сервисом Рау, стикером, в&nbsp;Интернете
            с&nbsp;подпиской (5% - без&nbsp;подписки);
          </li>
          <li>
            — 10% - за поездку на такси «Яндекс&nbsp;Go» с&nbsp;подпиской (5% - без&nbsp;подписки).
          </li>
        </ul>
        <br />
        <p>Покупка не у партнеров и&nbsp;оплата ЖКХ**:</p>
        <br />
        <ul>
          <li>— 2% - с подпиской (1% - без&nbsp;подписки).</li>
        </ul>
        <br />
        <p>
          * Если за отчетный период накоплено менее&nbsp;300&nbsp;баллов,
          то&nbsp;они&nbsp;переносятся на&nbsp;следующий отчетный период и&nbsp;суммируются
          с&nbsp;баллами, которые будут в&nbsp;нем накоплены. Продолжайте активно пользоваться
          картой, чтобы быстрее накопить необходимое для&nbsp;возмещения количество баллов.
        </p>
        <br />
        <p>
          ** Кэшбэк начисляется за оплату ЖКХ собственными и&nbsp;заемными средствами
          в&nbsp;приложении{" "}
          <AppLink target="_blank" href="https://pwa.scb.ru/" rel="noreferrer">
            «Халва&nbsp;-&nbsp;Совкомбанк»
          </AppLink>{" "}
          или&nbsp;
          <AppLink target="_blank" href="https://halvacard.ru/lk2/" rel="noreferrer">
            личном кабинете
          </AppLink>
          .
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Проценты на остаток собственных средств</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          С Халвой удобно управлять личными финансами: храните на ней деньги и получайте пассивный
          доход — проценты на минимальный остаток на счете собственных средств.
        </p>
        <br />
        <p>
          Чтобы открыть максимум преимуществ, оформите подписку «Халва.Десятка». Вы получаете{" "}
          <span className={styles.fw_bold}>17%&nbsp;годовых</span> первые 3 мес. после выдачи карты
          (для впервые оформленных договоров),{" "}
          <span className={styles.fw_bold}>15%&nbsp;годовых</span> с 4-го месяца. Проценты
          начисляются на остаток до 400&nbsp;000 руб. Без подписки и на сумму свыше 400&nbsp;000
          руб. проценты не начисляются.
        </p>
        <br />
        <p>Копите с выгодой, не теряя возможности распоряжаться своими деньгами без ограничений.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Бесплатные выпуск и обслуживание</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          Карта «Халва» абсолютно бесплатна! Вам не придется платить ни за выпуск, ни за
          обслуживание.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Оформление и получение</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          Оформить карту можно не выходя из дома. Оставьте онлайн-заявку, дождитесь звонка
          сотрудника банка, подтвердите свои данные. Получить Халву можно в одном из отделений
          Совкомбанка или заказав бесплатную курьерскую доставку.
        </p>
      </div>,
    ],
  ],
  procentyVernetMagazin: [
    [
      <p className={styles.listQuestion}>Управляйте одной картой</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          Удобно, когда все платежные инструменты сосредоточены в одной карте. Халвой можно
          пользоваться как обычной дебетовой картой и при этом гасить долг комфортными ежемесячными
          платежами. Она помогает равномерно распределить финансовую нагрузку.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Повышенный кэшбэк</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          <AppLink
            target="_blank"
            href="https://peertube-ext.sovcombank.ru/videos/embed/2d899559-cc79-471f-a14b-300726b65cdf?title=0&warningTitle=0&controlBar=0&peertubeLink=0"
            rel="noreferrer"
          >
            Баллы кэшбэка
          </AppLink>{" "}
          начисляются за&nbsp;любые покупки собственными средствами. Они суммируются
          и&nbsp;становятся доступными для&nbsp;возмещения (обмена на&nbsp;рубли)
          после&nbsp;окончания каждого отчетного периода, если&nbsp;в&nbsp;нем накоплено
          от&nbsp;300&nbsp;баллов*
        </p>
        <br />
        <p>
          При подключении подписки{" "}
          <AppLink target="_blank" href="https://halvacard.ru/halvadesyatka" rel="noreferrer">
            «Халва.Десятка»
          </AppLink>{" "}
          кэшбэк УДВАИВАЕТСЯ!
        </p>
        <br />
        <p>
          <div className={styles.subtitle}>Размер кэшбэка c подпиской</div>
        </p>
        <br />
        <p>Покупка у партнеров Халвы:</p>
        <br />
        <ul>
          <li>— 4% - с подпиской (2% - без&nbsp;подписки);</li>
          <li>
            — 10% - за покупку от 10 000 р. сервисом Рау, стикером, в&nbsp;Интернете
            с&nbsp;подпиской (5% - без&nbsp;подписки);
          </li>
          <li>
            — 10% - за поездку на такси «Яндекс&nbsp;Go» с&nbsp;подпиской (5% - без&nbsp;подписки).
          </li>
        </ul>
        <br />
        <p>Покупка не у партнеров и&nbsp;оплата ЖКХ**:</p>
        <br />
        <ul>
          <li>— 2% - с подпиской (1% - без&nbsp;подписки).</li>
        </ul>
        <br />
        <p>
          * Если за отчетный период накоплено менее&nbsp;300&nbsp;баллов,
          то&nbsp;они&nbsp;переносятся на&nbsp;следующий отчетный период и&nbsp;суммируются
          с&nbsp;баллами, которые будут в&nbsp;нем накоплены. Продолжайте активно пользоваться
          картой, чтобы быстрее накопить необходимое для&nbsp;возмещения количество баллов.
        </p>
        <br />
        <p>
          ** Кэшбэк начисляется за оплату ЖКХ собственными и&nbsp;заемными средствами
          в&nbsp;приложении{" "}
          <AppLink target="_blank" href="https://pwa.scb.ru/" rel="noreferrer">
            «Халва&nbsp;-&nbsp;Совкомбанк»
          </AppLink>{" "}
          или&nbsp;
          <AppLink target="_blank" href="https://halvacard.ru/lk2/" rel="noreferrer">
            личном кабинете
          </AppLink>
          .
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Бесплатные выпуск и обслуживание</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          Карта «Халва» абсолютно бесплатна! Вам не придется платить ни за выпуск, ни за
          обслуживание.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Оформление и получение</p>,
      <div className={styles.wrapperListAnswer}>
        <p>
          Оформить карту можно не выходя из дома. Оставьте онлайн-заявку, дождитесь звонка
          сотрудника банка, подтвердите свои данные. Получить Халву можно в одном из отделений
          Совкомбанка или заказав бесплатную курьерскую доставку.
        </p>
      </div>,
    ],
  ],
  media: [
    [
      <p className={styles.listQuestion}>Управляйте одной картой</p>,
      <div className={styles.listAnswer}>
        <p>
          Удобно, когда все платежные инструменты сосредоточены в одной карте. Халвой можно
          пользоваться как обычной дебетовой картой и при этом гасить долг комфортными ежемесячными
          платежами. Она помогает равномерно распределить финансовую нагрузку.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Повышенный кэшбэк </p>,
      <div className={styles.listAnswer}>
        <p>
          Карта рассрочки* «Халва» выступает источником заемных средств, служит дебетовым пластиком
          и восполняет часть потраченных денег. Далеко не каждая дебетовая карта имеет такой набор
          опций, а у кредитных они и вовсе отсутствуют.
        </p>
        <br />
        <p>
          Халва открывает доступ к самым выгодным предложениям Совкомбанка. Клиенты, оформившие
          подписку «Халва.Десятка», пользуются максимальными привилегиями. А при выполнении простых
          условий банк возвращает стоимость подписки.
        </p>
        <br />
        <p>
          <div className={styles.subtitle}>Сколько можно вернуть кэшбэком?</div>
        </p>
        <p>
          <AppLink
            target="_blank"
            href="https://peertube-ext.sovcombank.ru/videos/embed/2d899559-cc79-471f-a14b-300726b65cdf?title=0&warningTitle=0&controlBar=0&peertubeLink=0"
            rel="noreferrer"
          >
            Баллы кэшбэка
          </AppLink>{" "}
          начисляются за&nbsp;любые покупки собственными средствами. Они суммируются
          и&nbsp;становятся доступными для&nbsp;возмещения (обмена на&nbsp;рубли)
          после&nbsp;окончания каждого отчетного периода, если&nbsp;в&nbsp;нем накоплено
          от&nbsp;300&nbsp;баллов*
        </p>
        <br />
        <p>
          При подключении подписки{" "}
          <AppLink target="_blank" href="https://halvacard.ru/halvadesyatka" rel="noreferrer">
            «Халва.Десятка»
          </AppLink>{" "}
          кэшбэк УДВАИВАЕТСЯ!
        </p>
        <br />
        <p>
          <div className={styles.subtitle}>Размер кэшбэка c подпиской</div>
        </p>
        <br />
        <p>Покупка у партнеров Халвы:</p>
        <br />
        <ul>
          <li>— 4% - с подпиской (2% - без&nbsp;подписки);</li>
          <li>
            — 10% - за покупку от 10 000 р. сервисом Рау, стикером, в&nbsp;Интернете
            с&nbsp;подпиской (5% - без&nbsp;подписки);
          </li>
          <li>
            — 10% - за поездку на такси «Яндекс&nbsp;Go» с&nbsp;подпиской (5% - без&nbsp;подписки).
          </li>
        </ul>
        <br />
        <p>Покупка не у партнеров и&nbsp;оплата ЖКХ**:</p>
        <br />
        <ul>
          <li>— 2% - с подпиской (1% - без&nbsp;подписки).</li>
        </ul>
        <br />
        <p>
          * Если за отчетный период накоплено менее&nbsp;300&nbsp;баллов,
          то&nbsp;они&nbsp;переносятся на&nbsp;следующий отчетный период и&nbsp;суммируются
          с&nbsp;баллами, которые будут в&nbsp;нем накоплены. Продолжайте активно пользоваться
          картой, чтобы быстрее накопить необходимое для&nbsp;возмещения количество баллов.
        </p>
        <br />
        <p>
          ** Кэшбэк начисляется за оплату ЖКХ собственными и&nbsp;заемными средствами
          в&nbsp;приложении{" "}
          <AppLink target="_blank" href="https://pwa.scb.ru/" rel="noreferrer">
            «Халва&nbsp;-&nbsp;Совкомбанк»
          </AppLink>{" "}
          или&nbsp;
          <AppLink target="_blank" href="https://halvacard.ru/lk2/" rel="noreferrer">
            личном кабинете
          </AppLink>
          .
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Проценты на остаток собственных средств</p>,
      <div className={styles.listAnswer}>
        <p>
          Владельцам карт, которые не тратят со счета все до последней копейки, Халва также выгодна
          — банк начисляет процент на остаток средств.
        </p>
        <br />
        <p>
          <div className={styles.subtitle}>Как получить максимальную выгоду?</div>
        </p>
        <p>
          Оформите карту и подпишитесь на «Халву.Десятку». С подпиской в течение трех месяцев вы
          будете получать 17% годовых на остаток собственных средств на карте. Чтобы опция
          сработала, совершите за месяц пять покупок на сумму от 10 000 рублей.
        </p>
        <br />
        <p>
          Повышенный процент начисляется на остаток денег до 400 000 рублей. При остатке средств
          более 400 000 рублей действует ставка 5% годовых
        </p>
        <br />
        <p>
          С четвертого месяца повышенная годовая ставка на остаток средств на карте равна 9% (при
          подключенной подписке).
        </p>
        <br />
        <p>
          <div className={styles.subtitle}>А какой бонус без подписки «Халва.Десятка»? </div>
        </p>
        <p>
          Если вы ежемесячно совершаете пять покупок на сумму от 10 000 рублей, банк начисляет 6%
          годовых на остаток средств на счете.
        </p>
        <br />
        <p>
          <div className={styles.subtitle}>Сколько получит клиент, редко пользующийся картой?</div>
        </p>
        <p>
          В этом случае достаточно совершить одну покупку, чтобы рассчитывать на 5% годовых на
          минимальный остаток.
        </p>
        <br />
        <p>Копите деньги на карте и получайте пассивный доход.</p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Бесплатные выпуск и обслуживание</p>,
      <div className={styles.listAnswer}>
        <p>
          Карта «Халва» абсолютно бесплатна! Вам не надо платить ни за выпуск, ни за обслуживание.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Удобное оформление и получение</p>,
      <div className={styles.listAnswer}>
        <p>
          Оформить карту можно не выходя из дома. Оставьте онлайн-заявку, дождитесь звонка
          сотрудника банка, подтвердите свои данные. Получить Халву можно в одном из отделений
          Совкомбанка или заказав бесплатную курьерскую доставку.
        </p>
      </div>,
    ],
  ],
  default: [
    [
      <p className={styles.listQuestion}>Беспроцентная рассрочка* до 10 месяцев</p>,
      <div className={styles.listAnswer}>
        <p>
          Не хочется переплачивать по кредитным обязательствам? Мечту только сегодня можно купить со
          скидкой, а денег не хватает? Хорошо, что есть карта рассрочки* «Халва». Понравившийся
          товар в любом из более чем 260 000 магазинов-партнеров можно купить сразу, а оплачивать
          частями. Два, три или даже десять месяцев. И не нужно подстраиваться под льготный период,
          как в случае с кредитной картой, и переживать о процентной ставке.
        </p>
        <br />
        <p>
          Оплачиваете только стоимость товара из ограниченной суммы заемных денег на карте и
          получаете заказ. Никаких кредитных договоров и рассрочек* дополнительно оформлять не
          понадобится.
        </p>
        <br />
        <p>
          Стоимость приобретенного товара делится на равные платежи, которые ежемесячно списываются
          из собственных денег (автоматически, если подключите такую опцию) на протяжении всего
          срока.
        </p>
        <br />
        <p>
          Вам остается только своевременно пополнять пластик перед датой списания и одним нажатием
          гасить задолженность.
        </p>
        <br />
        <p>
          С длительной рассрочкой* не придется искать деньги на погашение займа уже через несколько
          недель после траты. В отличие от кредитной карты, по которой проценты на сумму долга (по
          ставке 30–60% годовых) будут начисляться, как только кончится короткий льготный период.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>
        Срочно нужны наличные? Их также можно взять в рассрочку*
      </p>,
      <div className={styles.listAnswer}>
        <p>
          Халва не ограничивается виртуальным пространством и расширяет границы возможностей за
          пределы интернета.
        </p>
        <br />
        <p>
          Вам доступно снятие наличных в любом банкомате в рассрочку* на три месяца под 0% годовых с
          подпиской{" "}
          <AppLink target="_blank" href="https://halvacard.ru/halvadesyatka" rel="noreferrer">
            «Халва.Десятка»
          </AppLink>{" "}
          (без подписки на 2 мес.). Снять можно любую нужную сумму.
        </p>
        <br />
        <p>
          За один раз можно снять только до 30 000 рублей. На количество таких операций ограничений
          нет, в рамках лимита вы можете получить на руки любую необходимую сумму.
        </p>
        <br />
        <p>
          Снять деньги можно за 399 рублей. Стоимость услуги будет включена в ближайший ежемесячный
          платеж.
        </p>
        <br />
        <p>
          Не нужно брать на себя кредитные обязательства. Наличные выдаются бесплатно (при условии
          возврата за три месяца) — это реально с картой рассрочки*.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Повышенный кэшбэк</p>,
      <div className={styles.listAnswer}>
        <p>
          Используйте карту рассрочки* от Совкомбанка как универсальный инструмент: не только в
          качестве источника заемных средств, но и как дебетовый пластик. С кредитными картами
          подобные варианты недоступны. Да и не все дебетовые карты могут предложить выгодные
          условия пользования.
        </p>
        <br />
        <p>
          Храните на ней деньги, копите, берите с собой на шопинг и получайте повышенный кэшбэк до
          10% с подпиской «Халва.Десятка».
        </p>
        <br />
        <p>
          1 балл кэшбэка = 1 рубль Максимальное количество баллов в месяц — 5000. Заработать их
          можно разными способами.
        </p>
        <br />
        <p>
          Например, оформите подписку «Халва.Десятка» и отправляйтесь на онлайн-шопинг в любой из
          партнерских магазинов. За покупку от 50 000 руб. своими средствами у всех партнеров Халвы
          при оплате сервисом Рау, Платёжным стикером или в Интернете – кэшбэк 10%.
        </p>
        <br />
        <p>Без подписки и с меньшим чеком также можно получать приятные бонусы.</p>
        <br />
        <p>
          За шопинг у партнеров на сумму от 10 000 рублей получайте возврат в размере 6% от чека.
        </p>
        <br />
        <p>
          Сделайте заказ или оплатите товары на сумму от 5000 до 9999,99 рублей и получите возврат в
          размере 4%.
        </p>
        <br />
        <p>За покупку до 4999,99 рублей на карту вернутся 2% от суммы.</p>
        <br />
        <p>2% - кэшбэк за любую покупку картой.</p>
        <br />
        <p>
          Кэшбэк 1% начисляется и за оплату ЖКХ в приложении{" "}
          <AppLink
            href="https://pwa.scb.ru/"
            target="_blank"
            rel="noreferrer"
            className={styles.link_text_small}
          >
            «Халва-Совкомбанк»
          </AppLink>{" "}
          или{" "}
          <AppLink
            href="https://halvacard.ru/lk"
            target="_blank"
            rel="noreferrer"
            className={styles.link_text_small}
          >
            Личном кабинете
          </AppLink>
          .
        </p>
        <br />
        <p>За покупки у не партнеров кэшбэк составит 1%.</p>
        <br />
        <p>
          Баллы кэшбэка начисляются ежемесячно по окончании текущего отчетного периода. Их можно
          обменять на рубли, накопив от 300 баллов. Если набрали меньше, баллы не сгорят, а
          перенесутся на следующий месяц.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Выгода по вкладу держателям карты «Халва»</p>,
      <div className={styles.listAnswer}>
        <p>
          При оформлении срочных вкладов все&nbsp;владельцы карты «Халва» могут получить
          дополнительные 5% к&nbsp;основной ставке.
        </p>
        <br />
        <p>
          Ставка повышается на&nbsp;+2% на&nbsp;сроке 24&nbsp;мес., на&nbsp;+5% на&nbsp;сроке
          36&nbsp;мес. и&nbsp;на&nbsp;+1% на&nbsp;других сроках (по&nbsp;окончании действия вклада
          на&nbsp;сумму до&nbsp;1,5&nbsp;млн&nbsp;₽). Для&nbsp;получения дополнительных процентов
          в&nbsp;течение 14&nbsp;дней после открытия вклада нужно оформить Халву и&nbsp;подключить
          подписку «Халва.Десятка»; на&nbsp;протяжении действия вклада ежемесячно выполнять
          ПРАВИЛО&nbsp;10х20; не&nbsp;отключать подписку; не&nbsp;допускать просрочек по&nbsp;любым
          продуктам Совкомбанка.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>0 ₽ за выпуск и обслуживание карты</p>,
      <div className={styles.listAnswer}>
        <p>
          Чтобы оформить и использовать большинство дебетовых, а также кредитных карт, нужно
          платить. Разово за выпуск и ежемесячно за обслуживание. Открыть кредитную карту легко, но
          не так легко будет выполнять все условия и выплачивать ставку.
        </p>
        <br />
        <p>
          Мы же предлагаем бесплатное оформление. За использование и доставку карты плата также не
          взимается.
        </p>
        <br />
        <p>Бонус: 0 рублей за уведомления по операциям и полностью бесплатное обслуживание.</p>
        <br />
        <p>
          За мгновенный выпуск вам тоже не придется платить. И абсолютно бесплатный мгновенный
          перевыпуск.
        </p>
      </div>,
    ],
    [
      <p className={styles.listQuestion}>Оформление и получение</p>,
      <div className={styles.listAnswer}>
        <p>Нет времени на посещение офиса, сбор документов и заполнение множества форм?</p>
        <br />
        <p>
          Наш уникальный банковский продукт создан для решения всех этих проблем. При этом в банк
          идти необязательно: оформить карту можно онлайн в любое время. Для этого заполните
          короткую форму заявки и дождитесь ответа банка. Сотрудник перезвонит вам, расскажет обо
          всем подробнее и уточнит некоторые важные моменты, например стаж работы или минимальный
          доход. В банке должны иметь представление о будущем клиенте.
        </p>
        <br />
        <p>
          Выберите способ получения. Универсальный пластик можно забрать в ближайшем отделении
          Совкомбанка или оформить бесплатную доставку курьером. Услуга доступна жителям 74 регионов
          Российской Федерации.
        </p>
      </div>,
    ],
  ],
}

const documents_list = (mode: string = "") => {
  switch (mode) {
    case "refin":
      return [
        [
          <p className={styles.listQuestion}>Тарифы</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/18703"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Тарифы комиссионного вознаграждения по карте Халва
                <span className={styles.documentsSize}>396 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Условия Договора потребительского кредита</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13889"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия по продукту Карта Халва
                <span className={styles.documentsSize}>554 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13888"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия по продукту Карта Халва с лимитом 0,1 руб
                <span className={styles.documentsSize}>725 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/16329"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Уведомление
                <span className={styles.documentsSize}>221 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Программы лояльности</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/2777"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Программа лояльности для держателей Халвы
                <span className={styles.documentsSize}>444 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Памятки</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/2542"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Инструкция по переключению режимов Халвы
                <span className={styles.documentsSize}>581 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/3492"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общая информация по лимитам
                <span className={styles.documentsSize}>235 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/10340"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Памятка по безопасному пользованию банковскими картами
                <span className={styles.documentsSize}>870 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/1619"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Правила банковского обслуживания физических лиц в ПАО «Совкомбанк»
                <span className={styles.documentsSize}>510 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/11630"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия использования банковских карт
                <span className={styles.documentsSize}>908 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://prod-api.scb.ru/documents/16554"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия перевода ДС с&nbsp;использованием СБП платежной&nbsp;системы
                <span className={styles.documentsSize}>297 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Все акции карты «Халва» </p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/pages/vse-aktsii-karti-halva-"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Все акции карты «Халва»
                <span className={styles.documentsSize}>444 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
      ]
    case "sticker":
      return [
        [
          <p className={styles.listQuestion}>Тарифы</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={cn(styles.documentsBlock, styles.modeSticker)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13600"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Тарифы Халвау (действуют с&nbsp;01.09.2025 г.)
                <span className={styles.documentsSize}>244 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Документы и памятки</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding, styles.listStickerMode)}>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/4477"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Правила выпуска и&nbsp;обслуживания ВПК
                <span className={styles.documentsSize}>591 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/4478"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Правила осуществления переводов ЭДС
                <span className={styles.documentsSize}>540 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/1622"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия предоставления услуги Перевод с&nbsp;карты на&nbsp;карту для клиентов ПАО
                Совкомбанк (действует с&nbsp;1.02.16)
                <span className={styles.documentsSize}>382 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/1623"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия проведения банковских операций через дистанционные каналы обслуживания
                <span className={styles.documentsSize}>546 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/1647"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Памятка держателя банковских карт ПАО Совкомбанк
                <span className={styles.documentsSize}>310 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/5440"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Меры безопасности использования каналов дистанционного банковского обслуживания
                <span className={styles.documentsSize}>559 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/398"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия использования банковских карт (с&nbsp;01.09.2025)
                <span className={styles.documentsSize}>930 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/1619"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Правила банковского обслуживания физических лиц в&nbsp;ПАО «Совкомбанк» (действует
                с&nbsp;01.09.2025)
                <span className={styles.documentsSize}>1 МБ</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/10340"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Памятка по безопасному пользованию банковскими картами
                <span className={styles.documentsSize}>1 МБ</span>
              </AppLink>
            </div>
          </div>,
        ],
      ]
    case "productCategories":
      return [
        [
          <p className={styles.listQuestion}>Тарифы</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/11901"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Поставщики услуг Федеральной Системы «Город» Приложение №1 к&nbsp;Тарифам Халвы
                <span className={styles.documentsSize}>398 Кб</span>
              </AppLink>
            </div>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13792"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Тарифы комиссионного вознаграждения по&nbsp;карте Халва
                <span className={styles.documentsSize}>496 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Условия Договора потребительского кредита</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13889"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия по&nbsp;продукту Карта Халва
                <span className={styles.documentsSize}>652 Кб</span>
              </AppLink>
            </div>

            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/12956"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Стандарты по&nbsp;карте Халва
                <span className={styles.documentsSize}>650 Кб</span>
              </AppLink>
            </div>

            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13888"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия по&nbsp;продукту Карта Халва с&nbsp;лимитом 0,1 руб
                <span className={styles.documentsSize}>442 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/16329"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Уведомление
                <span className={styles.documentsSize}>221 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Программы лояльности</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/2777"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Программа лояльности для держателей Халвы
                <span className={styles.documentsSize}>442 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],

        [
          <p className={styles.listQuestion}>Памятки</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/pages/aktualnyje-pamyatki"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Полный перечень страховых памяток
              </AppLink>
            </div>

            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/10340"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Памятка по безопасному пользованию банковскими картами
                <span className={styles.documentsSize}>850 Кб</span>
              </AppLink>
            </div>

            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/1619"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Правила банковского обслуживания физических лиц в&nbsp;ПАО «Совкомбанк»{" "}
                <span className={styles.documentsSize}>499 Кб</span>
              </AppLink>
            </div>

            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/2542"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Инструкция по&nbsp;переключению режимов Халвы{" "}
                <span className={styles.documentsSize}>493 Кб</span>
              </AppLink>
            </div>

            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/3492"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общая информация по&nbsp;лимитам<span className={styles.documentsSize}>317 Кб</span>
              </AppLink>
            </div>

            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/11630"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия использования банковских карт{" "}
                <span className={styles.documentsSize}>340 Кб</span>
              </AppLink>
            </div>

            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://prod-api.scb.ru/documents/16554"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия перевода ДС с&nbsp;использованием СБП платежной&nbsp;системы{" "}
                <span className={styles.documentsSize}>297 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
      ]

    case "creditCard":
      return [
        [
          <p className={styles.listQuestion}>Тарифы</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13792"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Тарифы комиссионного вознаграждения по карте Халва
                <span className={styles.documentsSize}>503 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Условия Договора потребительского кредита</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13889"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия по продукту Карта Халва
                <span className={styles.documentsSize}>655 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13888"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия по продукту Карта Халва с лимитом 0,1 руб
                <span className={styles.documentsSize}>655 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/16329"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Уведомление
                <span className={styles.documentsSize}>221 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Программы лояльности</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/2777"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Программа лояльности для держателей Халвы
                <span className={styles.documentsSize}>444 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Памятки</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/2542"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Инструкция по переключению режимов Халвы
                <span className={styles.documentsSize}>581 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/3492"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общая информация по лимитам
                <span className={styles.documentsSize}>235 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/10340"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Памятка по безопасному пользованию банковскими картами
                <span className={styles.documentsSize}>870 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/1619"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Правила банковского обслуживания физических лиц в ПАО «Совкомбанк»
                <span className={styles.documentsSize}>510 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/11630"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия использования банковских карт
                <span className={styles.documentsSize}>908 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://prod-api.scb.ru/documents/16554"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия перевода ДС с&nbsp;использованием СБП платежной&nbsp;системы
                <span className={styles.documentsSize}>297 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Все акции карты «Халва» </p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/pages/vse-aktsii-karti-halva-"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Все акции карты «Халва»
                <span className={styles.documentsSize}>444 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
      ]

    case "debet":
      return [
        [
          <p className={styles.listQuestion}>Тарифы</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13894"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Тариф по дебетовой карте с процентом на остаток
                <span className={styles.documentsSize}>490 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13796"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Тарифы по продукту Дебетовая Халва
                <span className={styles.documentsSize}>490 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/14305"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Тарифы по дебетовым картам
                <span className={styles.documentsSize}>490 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13698"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Тарифы по дебетовым картам с кэшбэком
                <span className={styles.documentsSize}>490 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Программы лояльности</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/2777"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Программа лояльности для держателей Халвы
                <span className={styles.documentsSize}>444 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/11760"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Программа лояльности по Дебетовой карте Совкомбанка
                <span className={styles.documentsSize}>553 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/18205"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Программа лояльности для ДК с кешбэком на всё
                <span className={styles.documentsSize}>880 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/18179"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Программа лояльности для ДК с кешбэком на категории
                <span className={styles.documentsSize}>728 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/16969"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Программа лояльности ДК для Арбитражных управляющих
                <span className={styles.documentsSize}>485 Кб</span>
              </AppLink>
            </div>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/18649"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Программа лояльности для ДК с ГОС кешбэком до 6%
                <span className={styles.documentsSize}>700 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Памятки</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/2542"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Инструкция по переключению режимов Халвы
                <span className={styles.documentsSize}>581 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/3492"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общая информация по лимитам
                <span className={styles.documentsSize}>235 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/10340"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Памятка по безопасному пользованию банковскими картами
                <span className={styles.documentsSize}>870 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/1619"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Правила банковского обслуживания физических лиц в ПАО «Совкомбанк»
                <span className={styles.documentsSize}>510 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/16329"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Уведомление
                <span className={styles.documentsSize}>221 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/11630"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия использования банковских карт
                <span className={styles.documentsSize}>908 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://prod-api.scb.ru/documents/16554"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия перевода ДС с&nbsp;использованием СБП платежной&nbsp;системы
                <span className={styles.documentsSize}>297 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Все акции карты «Халва» </p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/pages/vse-aktsii-karti-halva-"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Все акции карты «Халва»
                <span className={styles.documentsSize}>444 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
      ]
    case "pravdaCoffee":
      return [
        [
          <p className={styles.listQuestion}>Тарифы</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={clsx(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/11901"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Поставщики услуг Федеральной Системы «Город» Приложение №1 к&nbsp;Тарифам Халвы
                с&nbsp;01.05.2023
                <span className={styles.documentsSize}>397 Кб</span>
              </AppLink>
            </div>
            <div className={clsx(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/19468"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Тарифы комиссионного вознаграждения по&nbsp;карте Халва (действуют с&nbsp;20.09.2026
                г.)
                <span className={styles.documentsSize}>331 Кб</span>
              </AppLink>
            </div>
            <div className={clsx(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/11901"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Тарифы комиссионного вознаграждения по&nbsp;карте Халва (действуют с&nbsp;13.09.2026
                г.)
                <span className={styles.documentsSize}>332 Кб</span>
              </AppLink>
            </div>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13792"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Тарифы комиссионного вознаграждения по&nbsp;карте Халва (действуют с&nbsp;30.08.2026
                г.)
                <span className={styles.documentsSize}>331 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Условия Договора потребительского кредита</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/14505"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия для клиентов, переходящих на обслуживание в ПАО Совкомбанк с
                11.11.2024 (действуют с 29.07.2025 г.)
                <span className={styles.documentsSize}>627 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/15371"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия для клиентов, переходящих на обслуживание в ПАО Совкомбанк по картам
                Кредитная польза, 120 дней без %, 120 дней Лайт (действуют с 29.07.2025 г.)
                <span className={styles.documentsSize}>346 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/15372"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия для клиентов, переходящих на обслуживание в ПАО Совкомбанк по картам с
                кредитным лимитом Хоум карта (действуют с 29.07.2025 г.)
                <span className={styles.documentsSize}>347 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/15373"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия для клиентов, переходящих на обслуживание в ПАО Совкомбанк по карте
                (действуют с 29.07.2025 г.)
                <span className={styles.documentsSize}>345 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/15374"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия для клиентов, переходящих на обслуживание в ПАО Совкомбанк по карте
                рассрочки VK-pay (действуют с 29.07.2025 г.)
                <span className={styles.documentsSize}>519 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/15382"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия для клиентов, переходящих на обслуживание в ПАО Совкомбанк по карте
                рассрочки Свобода (действуют с 29.07.2025 г.)
                <span className={styles.documentsSize}>346 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/16329"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Уведомление
                <span className={styles.documentsSize}>216 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/19335"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Стандарты по карте Халва 30.08.2026
                <span className={styles.documentsSize}>531 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13889"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия по продукту Карта Халва (действуют с 28.06.2026 г.)
                <span className={styles.documentsSize}>530 Кб</span>
              </AppLink>
            </div>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13888"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия по продукту Карта Халва с лимитом 0,1 руб. (действуют с 28.06.2026 г.)
                <span className={styles.documentsSize}>526 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Программы лояльности</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/2777"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Программа лояльности для держателей Халвы
                <span className={styles.documentsSize}>402 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Памятки</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={clsx(styles.documentsBlock, styles.documentsBlockBorder)}>
              <AppLink
                href="https://scb.ru/pages/aktualnyje-pamyatki"
                target="_blank"
                rel="noreferrer"
              >
                Полный перечень страховых памяток
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/15118"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия перевода ДС в бюдж систему РФ с использ сервиса СБП с 15.02.2025
                <span className={styles.documentsSize}>415 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/18003"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Правила банковского обслуживания ФЛ в ПАО (действует с 21.04.2026)
                <span className={styles.documentsSize}>977 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/2542"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Инструкция по переключению режимов Халвы
                <span className={styles.documentsSize}>492 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/10340"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Памятка по безопасному пользованию банковскими картами
                <span className={styles.documentsSize}>1 1 179 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/11630"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия использования банковских карт (c 30.10.2025)
                <span className={styles.documentsSize}>912 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/16554"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия перевода ДС с использованием СБП платежной системы (Прил №17 с 02.06.2025)
                <span className={styles.documentsSize}>495 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/18212"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия предоставления услуг по платежам и переводам по реквизитам карт или СБП
                <span className={styles.documentsSize}>467 Кб</span>
              </AppLink>
            </div>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/3492"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общая информация по&nbsp;лимитам
                <span className={styles.documentsSize}>882 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Все акции карты «Халва» </p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={styles.documentsBlock}>
              <AppLink
                href="https://scb.ru/pages/vse-aktsii-karti-halva-"
                target="_blank"
                rel="noreferrer"
              >
                Все акции карты «Халва»
              </AppLink>
            </div>
          </div>,
        ],
      ]
    default:
      return [
        [
          <p className={styles.listQuestion}>Тарифы</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13792"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Тарифы комиссионного вознаграждения по карте Халва
                <span className={styles.documentsSize}>396 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Условия Договора потребительского кредита</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13889"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия по продукту Карта Халва
                <span className={styles.documentsSize}>655 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/13888"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общие условия по продукту Карта Халва с лимитом 0,1 руб
                <span className={styles.documentsSize}>655 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/16329"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Уведомление
                <span className={styles.documentsSize}>221 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Программы лояльности</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/2777"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Программа лояльности для держателей Халвы
                <span className={styles.documentsSize}>444 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Памятки</p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/2542"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Инструкция по переключению режимов Халвы
                <span className={styles.documentsSize}>581 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/3492"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Общая информация по лимитам
                <span className={styles.documentsSize}>235 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/10340"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Памятка по безопасному пользованию банковскими картами
                <span className={styles.documentsSize}>870 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/1619"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Правила банковского обслуживания физических лиц в ПАО «Совкомбанк»
                <span className={styles.documentsSize}>510 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock, styles.documentsBlockBorder)}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/document/11630"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия использования банковских карт
                <span className={styles.documentsSize}>908 Кб</span>
              </AppLink>
            </div>
            <div className={cn(styles.documentsBlock)}>
              <SvgPDF />
              <AppLink
                href="https://prod-api.scb.ru/documents/16554"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Условия перевода ДС с&nbsp;использованием СБП платежной&nbsp;системы
                <span className={styles.documentsSize}>297 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
        [
          <p className={styles.listQuestion}>Все акции карты «Халва» </p>,
          <div className={cn(styles.listAnswer, styles.listAnswerPadding)}>
            <div className={styles.documentsBlock}>
              <SvgPDF />
              <AppLink
                href="https://scb.ru/pages/vse-aktsii-karti-halva-"
                target="_blank"
                rel="noreferrer"
                className={styles.documentsLink}
              >
                Все акции карты «Халва»
                <span className={styles.documentsSize}>444 Кб</span>
              </AppLink>
            </div>
          </div>,
        ],
      ]
  }
}

export type ContentProps = {
  seoBlockText: string
  mode?:
    | "debet"
    | "zaimy"
    | "default"
    | "credit"
    | "refin"
    | "pkwRefin"
    | "bezProcentov"
    | "bezProcentov24MesMedia"
    | "bezProcentov36Mes"
    | "procentyVernetMagazin"
    | "media"
    | "productCategories"
    | "instruction"
    | "tgCashback"
    | "sticker"
    | "planetacard"
    | "creditCards"
    | "pravdacoffee"
  queryData?: QueryTypePsk | null
}

export const generateContent = ({ seoBlockText, mode = "default", queryData }: ContentProps) => {
  switch (mode) {
    case "creditCards":
      return [
        {
          title: "О карте",
          html: (
            <Content
              variant="creditCards"
              bottomText={
                <>
                  <p>
                    Зеленая цена — это специальная сниженная стоимость товара. Она подсвечивается
                    зелёным цветом в&nbsp;карточке товара / корзине в&nbsp;приложении «Ozon»
                    и&nbsp;позволяет мгновенно получить скидку до&nbsp;30%. Данная скидка заменит
                    кешбэк, который начисляться не&nbsp;будет
                  </p>
                  <br />
                  <p>
                    * льготный период не&nbsp;распространяется на&nbsp;снятие наличных
                    и&nbsp;переводы
                  </p>
                </>
              }
            />
          ),
        },
        {
          title: "Преимущества",
          html: (
            <div className={styles.benefitsList}>
              {BENEFITS_LIST_PKW_CREDIT_CARDS.map(({ title, descr }, index) => (
                <div key={index}>
                  <p className={styles.benefitTitle}>{title}</p>
                  <p className={styles.benefitDescr}>{descr}</p>
                </div>
              ))}
            </div>
          ),
        },
        {
          title: "Документы",
          html: (
            <>
              {DOCUMENTS_PKW_CREDIT_CARDS.map(({ text, href, size }, index) => (
                <AppLink
                  key={index}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  className={styles.documentPkwCreditCards}
                >
                  <SvgPDF />
                  <div>
                    {text}
                    <span className={styles.documentsSize}>{size}</span>
                  </div>
                </AppLink>
              ))}
            </>
          ),
        },
        {
          title: "Требования к заёмщику",
          html: (
            <div className={clsx(styles.htmlBlock, styles.creditCards)}>
              <ul>
                <li>— Гражданство РФ;</li>
                <li>— Паспорт гражданина РФ*;</li>
                <li>
                  — Возраст от 20 до 75 лет. На момент оформления кредитного договора возраст
                  74&nbsp;лет и&nbsp;11&nbsp;месяцев удовлетворяет требованиям, а&nbsp;ровно
                  75&nbsp;лет – нет;
                </li>
                <li>
                  — Официальное трудоустройство (стаж на&nbsp;последнем месте работы не&nbsp;менее
                  4&nbsp;месяцев);
                </li>
                <li>
                  — Наличие постоянной регистрации не&nbsp;менее 4 последних месяцев
                  на&nbsp;территории одного населенного пункта РФ;
                </li>
                <li>
                  — Проживание в городе присутствия подразделения Банка или&nbsp;в&nbsp;одном
                  из&nbsp;прилегающих населённых пунктов (но&nbsp;не&nbsp;более 70&nbsp;километров
                  от&nbsp;любого внутреннего структурного подразделения Банка);
                </li>
                <li>— Наличие личного мобильного телефона;</li>
                <li>— Рабочий телефон (стационарный/мобильный).</li>
              </ul>

              <p>
                * При необходимости или&nbsp;недостаточности сведений Банк имеет право запросить
                дополнительную информацию о&nbsp;клиенте (документы, подтверждающие владение
                имуществом: квартирой, транспортным средством и&nbsp;т.&nbsp;д.), в&nbsp;том числе
                и&nbsp;дополнительные документы (второй документ, удостоверяющий личность;
                документы, подтверждающие доход клиента).
              </p>
            </div>
          ),
        },
        {
          title: "Описание",
          html: (
            <div className={styles.benefitsList}>
              {DESCRIPRION_PKW_CREDIT_CARDS.map(({ title, descr }, index) => (
                <div key={index}>
                  <p className={styles.benefitTitle}>{title}</p>
                  <p className={styles.benefitDescr}>{descr}</p>
                </div>
              ))}
            </div>
          ),
        },
      ]
    case "zaimy":
      return [
        {
          title: "Тарифы",
          html: <Content variant="tariffs" />,
        },
        {
          title: "Документы",
          html: documents_list().map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Требования к заемщику",
          html: (
            <div className={styles.htmlBlock}>
              <ul>
                <li>Гражданство РФ;</li>
                <li>Паспорт РФ*;</li>
                <li>Возраст от 18 до 75 лет;</li>
                <li>
                  Официальное трудоустройство (стаж на последнем месте работы не менее 4 месяцев);
                </li>
                <li>
                  Наличие постоянной регистрации не менее 4 последних месяцев на территории одного
                  населенного пункта РФ, проживание в городе присутствия подразделения Банка или в
                  одном из прилегающих населенных пунктов (но не более 70 километров от любого
                  внутреннего структурного подразделения Банка);
                </li>
                <li>Наличие личного мобильного телефона.</li>
              </ul>
              <p className={styles.additionalText}>
                *При необходимости или недостаточности сведений Банк имеет право запросить
                дополнительную информацию о клиенте (документы, подтверждающие владение имуществом:
                квартирой, транспортным средством и т. д.), в том числе и дополнительные документы
                (второй документ, удостоверяющий личность; документы, подтверждающие доход клиента).
              </p>
            </div>
          ),
        },
        {
          title: "Часто задаваемые вопросы",
          html: QUESTIONS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Описание",
          html: seoBlockText,
        },
        {
          title: "Мнение эксперта",
          html: <ExpertOpinion {...EXPERT_ARTUR_SAFIN} />,
        },
      ]
    case "instruction":
      return [
        {
          title: "Социальные",
          html: QUESTIONS_LIST.instructionSocial.map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion withDataLayer eventAction="Социальные">
                {question}
              </FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "На обучение",
          html: QUESTIONS_LIST.instructionTraining.map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion withDataLayer eventAction="На обучение">
                {question}
              </FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "На лечение",
          html: QUESTIONS_LIST.instructionTreatment.map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion withDataLayer eventAction="На лечение">
                {question}
              </FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "На физкультурные услуги",
          html: QUESTIONS_LIST.instructionSport.map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion withDataLayer eventAction="На физкультурные услуги">
                {question}
              </FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Имущественные",
          html: QUESTIONS_LIST.instructionProperty.map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion withDataLayer eventAction="Имущественные">
                {question}
              </FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Для инвесторов",
          html: QUESTIONS_LIST.instructionInvestors.map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion withDataLayer eventAction="Для инвесторов">
                {question}
              </FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Инструкция",
          html: (
            <AppLink
              href={pdf3NDFL}
              target="_blank"
              rel="noreferrer"
              className={styles.documentLink}
              onClick={() =>
                DLClickEventExtended({
                  name: "Инструкция по заполнению 3-НДФЛ",
                  eventAction: "3-НДФЛ",
                  placement: "switcher_content",
                })
              }
            >
              <SvgPDF />
              <div>
                Инструкция по заполнению декларации
                <br />
                <b>3-НДФЛ</b>
                <span className={styles.documentsSize}>396 Кб</span>
              </div>
            </AppLink>
          ),
        },
      ]
    case "planetacard":
      return [
        {
          title: "Вопросы и ответы",
          html: QUESTIONS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Документы",
          html: (
            <AppLink
              href={pdfPlanetaCard}
              target="_blank"
              rel="noreferrer"
              className={styles.documentPlaneta}
            >
              <SvgPDF />
              <div>
                Паспорт продукта
                <span className={styles.documentsSize}>781 Кб</span>
              </div>
            </AppLink>
          ),
        },
      ]
    case "credit":
      return [
        {
          title: "О карте",
          html: <Content variant="aboutCredit" />,
        },
        {
          title: "Преимущества",
          html: <Content variant="benefitsCredit" />,
        },
        {
          title: "Документы",
          html: documents_list().map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Требования",
          html: <Requirements />,
        },
        {
          title: "Вопрос-ответ",
          html: QUESTIONS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Описание",
          html: seoBlockText,
        },
      ]
    case "refin":
      return [
        {
          title: "Условия",
          html: <Content variant="refinСonditions" />,
        },
        {
          title: "Требования",
          html: <RequirementsRefin />,
        },
        {
          title: "Преимущества",
          html: BENEFITS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClickRefin}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Документы",
          html: documents_list("refin").map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClickRefin}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Описание",
          html: seoBlockText,
        },
        {
          title: "Вопрос-ответ",
          html: QUESTIONS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClickRefin}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
      ]
    case "pkwRefin":
      return [
        {
          title: "Условия",
          html: <Content variant="pkwRefin" />,
        },
        {
          title: "Требования",
          html: <RequirementsRefin />,
        },
        {
          title: "Преимущества",
          html: BENEFITS_LIST.refin.map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClickRefin}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Документы",
          html: documents_list("refin").map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClickRefin}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Описание",
          html: seoBlockText,
        },
        {
          title: "Вопрос-ответ",
          html: QUESTIONS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClickRefin}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
      ]
    case "tgCashback":
      return [
        {
          title: "Условия",
          html: <Content variant="pkwRefin" />,
        },
        {
          title: "Требования",
          html: <RequirementsRefin />,
        },
        {
          title: "Преимущества",
          html: BENEFITS_LIST.refin.map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClickRefin}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Документы",
          html: documents_list("refin").map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClickRefin}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Вопрос-ответ",
          html: QUESTIONS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClickRefin}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
      ]
    case "sticker":
      return [
        {
          title: "Условия",
          html: <Content variant="sticker" />,
        },
        {
          title: "Преимущества",
          html: BENEFITS_LIST.sticker.map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClickRefin}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "О стикере Халвау",
          html: (
            <div className={styles.aboutStickerHalvau}>
              <div>
                <h4>Категория клиентов</h4>
                <p>
                  Оформить могут все владельцы Халвы для своих детей в&nbsp;возрасте от&nbsp;6
                  до&nbsp;18 лет.
                </p>
                <p>
                  На одного взрослого – количество оформленных стикеров без ограничений (оформитель
                  является родителем, при&nbsp;отсутствии родителей может оформить только опекун
                  с&nbsp;предоставлением соответствующего документа).
                </p>
              </div>
              <div>
                <h4>Порядок оформления</h4>
                <p>
                  Выдается только в&nbsp;офисах Банка на&nbsp;имя совершеннолетнего владельца Халвы.
                </p>
                <p>
                  Присутствие ребенка необязательно: взрослому достаточно назвать ФИО ребенка, номер
                  телефона.
                </p>
              </div>
              <div>
                <h4>Режим использования денежных средств </h4>
                <p>
                  Только собственные средства и безналичные операции. Ребенок может снимать
                  и&nbsp;переводить до&nbsp;3&nbsp;000&nbsp;₽ в&nbsp;месяц. При этом взрослый всегда
                  может контролировать траты ребёнка в&nbsp;мобильном приложении «Халва
                  —Совкомбанк».
                </p>
              </div>
              <div>
                <h4>Пополнение </h4>
                <p>Можно пополнять без комиссии:</p>
                <ul>
                  <li>— в приложении «Халва-Совкомбанк» с&nbsp;карты взрослого;</li>
                  <li>
                    — в устройствах самообслуживания Совкомбанка (необходимо следовать инструкции
                    в&nbsp;приложении).
                  </li>
                </ul>
                <p>
                  При пополнении через мобильные приложения и&nbsp;банкоматы других банков может
                  взиматься комиссия.
                </p>
              </div>
              <div>
                <h4>Установление лимита</h4>
                <p>
                  После оформления ХАЛВАУ появится у&nbsp;взрослого в&nbsp;приложении, где можно
                  будет переводить ребенку денежные средства без комиссии, отслеживать его расходы,
                  разрешать/запрещать использование денег за&nbsp;границей и&nbsp;устанавливать
                  лимиты:
                </p>
                <ul>
                  <li>— на безналичные операции;</li>
                  <li>— на переводы по&nbsp;номеру карты;</li>
                  <li>— на операции в&nbsp;Интернете.</li>
                </ul>
              </div>
            </div>
          ),
        },
        {
          title: "Акции",
          html: (
            <div>
              Участвовать в&nbsp;акциях может только родительская карта «Халва».{" "}
              <AppLink
                className={styles.link_text_default}
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/pages/vse-aktsii-karti-halva-"
              >
                Список акций
              </AppLink>
            </div>
          ),
        },
        {
          title: "Документы",
          html: documents_list("sticker").map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClickRefin}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Требования",
          html: <RequirementsSticker />,
        },
      ]
    case "bezProcentov":
      return [
        {
          title: "Условия",
          html: <Content variant="aboutCardWithoutPercent" queryData={queryData} />,
        },
        {
          title: "Требования",
          html: <Requirements subText={false} />,
        },
        {
          title: "Преимущества",
          html: BENEFITS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Вопрос-ответ",
          html: QUESTIONS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
      ]
    case "bezProcentov24MesMedia":
      return [
        {
          title: "Условия",
          html: <Content variant="aboutCardWithoutPercent36month" queryData={queryData} />,
        },
        {
          title: "Требования",
          html: <Requirements subText={false} />,
        },
        {
          title: "Преимущества",
          html: BENEFITS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Вопрос-ответ",
          html: QUESTIONS_LIST.bezProcentov.map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
      ]
    case "bezProcentov36Mes":
      return [
        {
          title: "Условия",
          html: <Content variant="aboutCardWithoutPercent36month" queryData={queryData} />,
        },
        {
          title: "Требования",
          html: <Requirements subText={false} />,
        },
        {
          title: "Преимущества",
          html: BENEFITS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Вопрос-ответ",
          html: QUESTIONS_LIST.bezProcentov.map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
      ]
    case "procentyVernetMagazin":
      return [
        {
          title: "Условия",
          html: <Content variant="procentyVernetMagazin" queryData={queryData} />,
        },
        {
          title: "Требования",
          html: <Requirements subText={false} />,
        },
        {
          title: "Преимущества",
          html: BENEFITS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Вопрос-ответ",
          html: QUESTIONS_LIST.procentyVernetMagazin.map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
      ]
    case "media":
      return [
        {
          title: "Условия",
          html: <Content variant="aboutCardWithoutPercent" />,
        },
        {
          title: "Требования",
          html: <Requirements subText={false} />,
        },
        {
          title: "Преимущества",
          html: BENEFITS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Вопрос-ответ",
          html: QUESTIONS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
      ]
    case "debet":
      return [
        {
          title: "Условия",
          html: <Content variant="debet" />,
        },
        {
          title: "Преимущества",
          html: BENEFITS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Документы",
          html: documents_list("debet").map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Требования",
          html: <Requirements />,
        },
        {
          title: "Вопрос-ответ",
          html: QUESTIONS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Описание",
          html: seoBlockText,
        },
        {
          title: "Мнение эксперта",
          html: <ExpertOpinion {...EXPERT_ILVINA_HAZIEVA} />,
        },
      ]
    case "productCategories":
      return [
        {
          title: "О карте",
          html: <Content variant="productCategories" />,
        },
        {
          title: "Требования",
          html: <RequirementsRefin />,
        },
        {
          title: "Документы",
          html: (
            <>
              {documents_list("productCategories").map(([question, answer], i) => (
                <FAQBlock key={i} onChange={handleClickRefin}>
                  <FAQQuestion>{question}</FAQQuestion>
                  <FAQAnswer>{answer}</FAQAnswer>
                </FAQBlock>
              ))}
              <MoreFiles />
            </>
          ),
        },
        {
          title: "Вопрос-ответ",
          html: QUESTIONS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClickRefin}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Описание",
          html: seoBlockText,
        },
      ]
    case "pravdacoffee":
      return [
        {
          title: "О карте",
          html: <Content variant="pravdaCoffee" />,
        },
        {
          title: "Преимущества",
          html: (
            <>
              <p className={styles.pointRedHalva}>
                <div className={styles.biggerTextAtPoint}>
                  <span className={styles.red}>36&nbsp;842&nbsp;836&nbsp;642&nbsp;₽</span>{" "}
                  вознаграждения уже получили владельцы ХАЛВЫ!
                </div>
                <AppLink
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  href="https://superbonushalva.sovcombank.ru"
                >
                  Заработать
                </AppLink>{" "}
                с Халвой
              </p>
              <br />
              {QUESTIONS_LIST[mode].map(([question, answer], i) => (
                <FAQBlock key={i} onChange={handleClick}>
                  <FAQQuestion>{question}</FAQQuestion>
                  <FAQAnswer>{answer}</FAQAnswer>
                </FAQBlock>
              ))}
              <br />
              <p style={{ fontStyle: "italic" }}>
                Общая памятка по тарифам карты «Халва» размещена{" "}
                <AppLink
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  href="https://scb.ru/document?id=2772"
                >
                  здесь
                </AppLink>
              </p>
              <br />
              <p style={{ fontStyle: "italic" }}>
                Получить всю информацию о тарифах, партнёрах,{" "}
                <AppLink
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  href="https://halvacard.ru/actions"
                >
                  акциях
                </AppLink>
                , скидках и периодах рассрочки можно на информационном{" "}
                <AppLink
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  href="https://halvacard.ru/"
                >
                  портале
                </AppLink>{" "}
                и по телефону горячей линии 8 (800) 100-777-2.
              </p>
              <br />
              <p style={{ fontStyle: "italic" }}>
                <sup className={styles.supIndex}>1</sup>Или платежей в разделе «Оплата услуг» в
                приложении{" "}
                <AppLink
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  href="https://pwa.scb.ru/"
                >
                  «Халва - Совкомбанк»
                </AppLink>{" "}
                или{" "}
                <AppLink
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  href="https://halvacard.ru/lk2/"
                >
                  Личном кабинете
                </AppLink>
                , или переводов заёмных средств (кроме СБП), или операций по снятию заёмных средств.
                Для карт{" "}
                <AppLink
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  href="https://scb.ru/pages/bonusi-s-sotsialnoi-kartoi-halva"
                >
                  «Социальная Халва»
                </AppLink>{" "}
                — от 10 000 ₽.
                <br />
                <sup className={styles.supIndex}>2</sup>Ставка повышается в конце срока и
                начисляется на общую сумму вкладов в банке до 1,5 млн ₽.
                <br />
                <sup className={styles.supIndex}>3</sup>Макс. 5000 баллов с подпиской
                «Халва.Десятка» (3000 – без подписки). Начисляется только при отсутствии просрочек
                по любым продуктам банка.
                <br />
                <sup className={styles.supIndex}>4</sup>1-й месяц бесплатно при условии, что клиент
                подключает подписку ВПЕРВЫЕ. Далее 3 799 за год или 399 рублей за месяц (для карт
                «Социальная Халва» 2 799 и 299 рублей). Годовая подписка может стать полностью
                бесплатной при выполнении простых{" "}
                <AppLink
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  href="https://halvacard.ru/halvadesyatka/"
                >
                  правил
                </AppLink>
                . Комиссия за годовую подписку при достаточности средств списывается в момент
                подключения услуги: из своих денег (в полном объеме) или из заемных (в рассрочку на
                4 мес.). При недостаточности средств комиссия за подписку уплачивается равными
                частями в 4 будущих платежа.
                <br />
                <sup className={styles.supIndex}>5</sup>1-й месяц бесплатно при условии, что клиент
                ВПЕРВЫЕ подключает Суперопцию вместе с подпиской. Далее 399 ₽ (для карт «Социальная
                Халва» — 299 ₽). Суперопция доступна только для карт с лимитом рассрочки.
                <br />
                <sup className={styles.supIndex}>6</sup>Если базовый срок рассрочки партнёра
                превышает 10 месяцев, то к покупке применяется базовый срок.
                <br />
                <sup className={styles.supIndex}>7</sup>По впервые открытым копилкам увеличенная
                базовая ставка начисляется первые 3 месяца на сумму свыше 1,5 млн руб., с 4-го
                месяца и по повторно открытым копилкам – на любую сумму.
                <br />
                <sup className={styles.supIndex}>8</sup>Действует для новых карт с датой оформления
                от 8.06.2026.
                <br />
                <sup className={styles.supIndex}>9</sup>Условия по своевременности платежей
                необходимо выполнять в течение 24 месяцев после получения увеличенного срока
                рассрочки. При невыполнении условий по мин. обороту и/или не закрытия
                рефинансированного кредита / кредитной карты в течение 45 дней — срок рассрочки
                пересчитывается и устанавливается на остаток задолженности равным: при наличии
                <AppLink
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                  href="https://halvacard.ru/halvadesyatka/"
                >
                  подписки «Халва.Десятка»
                </AppLink>{" "}
                — 10 мес. рассрочки, при отсутствии — 6 месяцев. Дополнительно в случае не закрытия
                кредита / кредитной карты в стороннем банке начисляется комиссия в размере 1/24 от
                общей суммы, направленной на рефинансирование кредитов (но не менее 4 999 ₽).
              </p>
            </>
          ),
        },
        {
          title: "Документы",
          html: documents_list("pravdaCoffee").map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Акции",
          html: (
            <div className={clsx(styles.htmlBlock, styles.creditCards)}>
              <AppLink
                rel="nofollow noopener noreferrer"
                target="_blank"
                href="https://scb.ru/pages/vse-aktsii-karti-halva-"
              >
                Все акции карты «Халва»
              </AppLink>
            </div>
          ),
        },
        {
          title: "Требования к заёмщику",
          html: (
            <div className={clsx(styles.htmlBlock, styles.creditCards)}>
              <ul>
                <li>— Гражданство РФ;</li>
                <li>— Возраст от 18 до 75 лет;</li>
                <li>
                  — Официальное трудоустройство (стаж на&nbsp;последнем месте работы не&nbsp;менее
                  4&nbsp;месяцев);
                </li>
                <li>
                  — Наличие постоянной регистрации не&nbsp;менее 4&nbsp;последних месяцев
                  на&nbsp;территории одного населённого пункта РФ, проживание в&nbsp;городе
                  присутствия подразделения Банка или&nbsp;в&nbsp;одном из прилегающих населённых
                  пунктов (но&nbsp;не&nbsp;более 70&nbsp;километров от&nbsp;любого внутреннего
                  структурного подразделения Банка);
                </li>
                <li>— Наличие личного мобильного телефона.</li>
              </ul>
              <br />
              <p>Для оформления Халвы достаточно только Паспорта РФ!*</p>
              <br />
              <p>
                * При необходимости или&nbsp;недостаточности сведений Банк имеет право запросить
                дополнительную информацию о&nbsp;клиенте (документы, подтверждающие владение
                имуществом: квартирой, транспортным средством и&nbsp;т. д.), в&nbsp;том числе
                и&nbsp;дополнительные документы (второй документ, удостоверяющий личность;
                документы, подтверждающие доход клиента).
              </p>
            </div>
          ),
        },
        {
          title: "Описание",
          html: (
            <div className={clsx(styles.htmlBlock, styles.creditCards)}>
              <p>
                Один из популярных финансовых продуктов – карта рассрочки. Её выбирают за
                возможность купить дорогую вещь с комфортным ежемесячным платежом в
                магазине-партнёров.
              </p>
              <br />
              <p className={styles.coffeTitle}>Что такое карта рассрочки?</p>
              <br />
              <p>
                Оформление карты Халва открывает перед пользователем двери в мир выгодных покупок.
                <br />
                Карты рассрочки обладают следующими характеристиками:
                <br />
                <ol>
                  <li>
                    Срок рассрочки составляет до 24-х месяцев. Продолжительность зависит от
                    магазина.
                  </li>
                  <li>
                    Рассрочка действует в магазинах-партнёрах банка. До оформления карты можно
                    узнать список торговых сетей и марок.
                  </li>
                  <li>Обслуживание бесплатное.</li>
                  <li>На карточке есть лимит заёмных средств – до 500 тысяч рублей.</li>
                  <li>
                    Выгодный кешбэк, процент можно увеличить, если оформить подписку
                    «Халва.Десятка».
                  </li>
                </ol>
              </p>
              <p className={styles.coffeTitle}>Преимущества карты «Халва» перед кредитной картой</p>
              <br />
              <p>
                Преимущества Халвы перед кредиткой:
                <br />
                <ol>
                  <li>Комфортные платежи и срок рассрочки.</li>
                  <li>
                    Большая партнерская сеть, состоящая из 260 000 магазинов-партнёров по всей
                    стране.
                  </li>
                  <li>Бесплатное обслуживание (кредитка очень часто платная).</li>
                  <li>
                    Оформить Халву и получить её на руки можно в день обращения. На предоставление
                    кредитки требуется время.
                  </li>
                  <li>
                    Халва обладает всеми функциями дебетовой карты: на ней можно хранить свои
                    средства и делать покупки с высоким кешбэком.
                  </li>
                </ol>
              </p>
              <p className={styles.coffeTitle}>Основные условия оформления</p>
              <br />
              <p>
                Чтобы оформить Халву, нужен только паспорт. Финансовый продукт оформят при
                соблюдении таких условий:
                <br />
                <ul>
                  <li>— гражданство РФ;</li>
                  <li>— возраст от 18 до 75 лет;</li>
                  <li>— время работы на последнем месте не менее 4 месяцев;</li>
                  <li>
                    — регистрация не менее 4 месяцев в населённом пункте с присутствием Совкомбанка.
                  </li>
                </ul>
              </p>
            </div>
          ),
        },
      ]
    default:
      return [
        {
          title: "Условия",
          html: <Content variant="standard" />,
        },
        {
          title: "Преимущества",
          html: BENEFITS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Документы",
          html: documents_list("creditCard").map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Требования",
          html: <Requirements />,
        },
        {
          title: "Вопрос-ответ",
          html: QUESTIONS_LIST[mode].map(([question, answer], i) => (
            <FAQBlock key={i} onChange={handleClick}>
              <FAQQuestion>{question}</FAQQuestion>
              <FAQAnswer>{answer}</FAQAnswer>
            </FAQBlock>
          )),
        },
        {
          title: "Описание",
          html: seoBlockText,
        },
        {
          title: "Мнение эксперта",
          html: <ExpertOpinion {...EXPERT_ALEXANDRA_MELNIK} />,
        },
      ]
  }
}
